<template>
  <div class="WrokForceDashboard">
    <div class="card p-4">
      <div class="heading">
        <h4 class="text-xl text-app-dashboard-heading" style="color: #e29d5a">
          Dashboard - Workforce Planning
        </h4>
      </div>

      <div class="tab mt-2">
        <div class="flex items-end ">
          <div class="input-box box-350">
            <!-- <p class="input-label">Locations</p> -->
            <base-locations-dropdown     @selectedLocationVal="dropDownUpdate" />
          </div>

          <div class="input-box box-220">
            <p class="input-label">Report</p>
            <el-select v-model="view" style="max-width: 300px" size="medium" placeholder="Select"
              @change="getDateByReportType('DASHBOARD')">
              <el-option v-for="(item, index) in viewList" :key="index" :value="item.id" :label="item.name">
                {{ item.name }}
              </el-option>
            </el-select>
          </div>

          <div class="input-box box-220">
            <p class="input-label">From Date</p>
            <el-date-picker v-model="fromDate" v-validate="'required'" type="date" size="medium" placeholder="Pick a day"
              :picker-options="firstDayOfWeek" name="fromDate" :disabled="view != 'wfr'">
            </el-date-picker>
            <p>
              <span :v-show="errors.has('fromDate')" class="text-red-dark text-xs">
                {{ errors.first("fromDate") ? "This field is required." : "" }}
              </span>
            </p>
          </div>

          <div class="input-box box-220">
            <p class="input-label">To Date</p>
            <el-date-picker v-model="toDate" v-validate="'required'" type="date" size="medium" placeholder="Pick a day" name="toDate"
              :picker-options="disabledStartDate" :disabled="view != 'wfr' || fromDate == null">
            </el-date-picker>
            <p>
              <span :v-show="errors.has('toDate')" class="text-red-dark text-xs">
                {{ errors.first("toDate") ? "This field is required." : "" }}
              </span>
            </p>
          </div>

          <div class="input-box box-220">
            <p class="input-label">Department</p>
            <el-select v-model="selectedDepartment" size="medium" placeholder="Select Department">
              <el-option key="all-dept" label="All" value="null"></el-option>
              <el-option v-for="item in departmentsList" :key="item.department" :label="item.department" :value="item.department">
              </el-option>
            </el-select>
          </div>

          <div>
            <el-button size="small" style="height: 36px" class="toggle-btn orng-btn" @click="goDashboard()">Go
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="show_wfd_data" class="graphTable">
      <el-card class="box-card pt-4 pb-4 graph-section">
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <!-- <div class="flex justify-between"> -->
            <div class="graph-card shadow-md">
              <div class="flex justify-end p-2">
                <span :class="[selectedLabourHrs == true ? 'selected-tab-heding' : 'tab-heding']"
                  @click="changedLabourGraph('labour hrs')">
                  Labour Hrs
                </span>
                |
                <span :class="[selectedLabourHrs == false ? 'selected-tab-heding' : 'tab-heding']"
                  @click="changedLabourGraph('labour cost')">
                  Labour Cost
                </span>
              </div>
              <BaseLabourHoursGraph id="baseLabourHourGraph" />
            </div>
            <!-- </div> -->
          </el-col>

          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <div class="graph-card shadow-md">
              <div class="flex justify-end p-2">
                <span :class="[selectedIplh == true ? 'selected-tab-heding' : 'tab-heding']"
                  @click="changedIplhGraph('IPLH')">
                  IPLH
                </span>
                |
                <span :class="[selectedIplh == false ? 'selected-tab-heding' : 'tab-heding']"
                  @click="changedIplhGraph('TPLH')">
                  TPLH
                </span>
              </div>
              <BaseIplhGraph id="baseIplhGraph" />
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <div class="graph-card shadow-md">
              <VarianceGraph id="varianceGraph" />
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <div class="graph-card shadow-md">
              <div id="basePieChart" class="flex">
                <div class="w-1/2">
                  <h5 class="text-center" style="position: relative; top: 40px">
                    Flexible(Part Time/Hourly)%
                  </h5>
                  <BasePieChart />
                </div>
                <div class="w-1/4">
                  <h5 class="mt-10 text-center">Gender</h5>
                  <div class="flex justify-center items-center mx-4 my-8">
                    <img class="mr-3" src="../../../assets/images/maleIcon.png" style="height: 35px" />
                    <div class="text-center">
                      <p style="color: #f6b26b">{{ consoleData.male_per }}%</p>
                      <p class="text-xs mt-2">Male</p>
                    </div>
                  </div>
                  <div class="flex justify-center items-center mx-4 my-8">
                    <img class="mr-3" src="../../../assets/images/femaleIcon.png" style="height: 35px" />
                    <div class="text-center">
                      <p style="color: #f9cb9c">
                        {{ consoleData.female_per }}%
                      </p>
                      <p class="text-xs mt-2">Female</p>
                    </div>
                  </div>
                </div>

                <div class="w-1/4">
                  <h5 class="mt-10 text-center">Shift Complement</h5>
                  <div class="flex justify-center items-center my-16 mx-4">
                    <img class="mr-3" src="../../../assets/images/compliment.png" style="height: 35px; width: 35px;" />
                    <div class="text-center">
                      <p style="color: #f6b26b">
                        {{ consoleData.shift_compliment }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <!-- <div class="flex justify-between"> -->
          <!-- </div> -->
        </el-row>
      </el-card>

      <div class="flex justify-end w-full py-2">
        <!-- <el-button-group class="toggle-btn-grp mr-4"> -->
        <!-- <el-button class="toggle-btn" size="mini" @click="createPDF()">
            Export To PDF
          </el-button> -->
        <!-- <el-button
            class="export-btn"
            size="mini"
            @click="downloadCsvReport('xlsx')"
          >
            EXCEL
          </el-button> -->
          <el-dropdown v-if="checkCompany.is_mcd" trigger="click" class="text-xs" @command="downloadAllCsvReports" style="margin-left: 10px;">
            <BaseButton :disabled="is_workforce_loading" size="medium" type="submit" style="width: 155px;" buttonclass="btn p-2 text-xs ">
              Download Reports<i class="pl-2 el-icon-download"></i>
            </BaseButton>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="consolidated">Consolidated report</el-dropdown-item>
              <el-dropdown-item command="pillar">4 Pillar Report</el-dropdown-item>
              <el-dropdown-item command="variance">Variance Report</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown v-else-if="checkCompany.is_sb_malaysia" trigger="click" class="text-xs" @command="downloadAllCsvReports" style="margin-left: 10px;">
            <BaseButton :disabled="is_workforce_loading" size="medium" type="submit" style="width: 155px;" buttonclass="btn p-2 text-xs ">
              Download Reports<i class="pl-2 el-icon-download"></i>
            </BaseButton>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="consolidated">Consolidated report</el-dropdown-item>
              <el-dropdown-item command="company">Company report</el-dropdown-item>
              <el-dropdown-item command="day_wise">Daywise report</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          
          <el-button v-else size="mini" type="warning" :loading="is_csv_loading" @click="downloadCsvReport('csv')">CSV&nbsp;&nbsp;<i class="el-icon-download"></i></el-button>
        <!-- <el-button size="mini" type="primary" plain>CSV ss<i class="el-icon-download" @click="downloadCsvReport('csv')"
            :loading="true"></i></el-button> -->
        <!-- </el-button-group> -->
      </div>

      <div class="text-white rounded-t flex items-center justify-between"
        style="background: #606060; padding: 10px 15px">
        <span style="width: 185px;"> Workforce Planning</span>
        <el-button-group class="toggle-btn-grp">
          <el-button class="toggle-btn" style="border-color: #606060" size="mini"
            :class="!is_actual_sales_toggled ? 'inactive-toggle-btn' : ''"
            :icon="is_actual_sales_toggled ? 'el-icon-close' : 'el-icon-check'"
            @click="is_actual_sales_toggled = !is_actual_sales_toggled">
            Sales
          </el-button>
          <el-button class="toggle-btn" style="border-color: #606060" size="mini"
            :class="!is_transactions_toggled ? 'inactive-toggle-btn' : ''"
            :icon="is_transactions_toggled ? 'el-icon-close' : 'el-icon-check'"
            @click="is_transactions_toggled = !is_transactions_toggled">
            Transactions
          </el-button>
          <el-button v-if="checkCompany.is_sb_malaysia" class="toggle-btn" style="border-color: #606060" size="mini"
            :class="!is_ipt_toggled ? 'inactive-toggle-btn' : ''"
            :icon="is_ipt_toggled ? 'el-icon-close' : 'el-icon-check'"
            @click="is_ipt_toggled = !is_ipt_toggled">
            IPT
          </el-button>
          <el-button class="toggle-btn" style="border-color: #606060" size="mini" :class="
                      !is_ideal_labour_hours_toggled ? 'inactive-toggle-btn' : ''
                    "
                    :icon="is_ideal_labour_hours_toggled ? 'el-icon-close' : 'el-icon-check'"
                    @click="
            is_ideal_labour_hours_toggled = !is_ideal_labour_hours_toggled
          ">
            Ideal Labour Hrs
          </el-button>

          <el-button class="toggle-btn" style="border-color: #606060" size="mini" :class="
            !is_scheduled_labour_hours_toggled ? 'inactive-toggle-btn' : ''
          " :icon="is_scheduled_labour_hours_toggled ? 'el-icon-close' : 'el-icon-check'"
           @click="is_scheduled_labour_hours_toggled = !is_scheduled_labour_hours_toggled">
            Scheduled Labour Hrs
          </el-button>

          <el-button class="toggle-btn" style="border-color: #606060" size="mini" :class="
            !is_actual_labour_hours_toggled ? 'inactive-toggle-btn' : ''
          " :icon="is_actual_labour_hours_toggled ? 'el-icon-close' : 'el-icon-check'"
           @click="is_actual_labour_hours_toggled = !is_actual_labour_hours_toggled">
            Actual Labour Hrs
          </el-button>

          <el-button class="toggle-btn" style="border-color: #606060" size="mini"
            :class="!is_wastage_hrs_toggled ? 'inactive-toggle-btn' : ''"
            :icon="is_wastage_hrs_toggled ? 'el-icon-close' : 'el-icon-check'"
            @click="is_wastage_hrs_toggled = !is_wastage_hrs_toggled">
            Wastage Hrs
          </el-button>

          <el-button class="toggle-btn" style="border-color: #606060" size="mini" :class="
            !is_variance_to_ideal_toggled ? 'inactive-toggle-btn' : ''
          " :icon="is_variance_to_ideal_toggled ? 'el-icon-close' : 'el-icon-check'"
          @click="is_variance_to_ideal_toggled = !is_variance_to_ideal_toggled">
            Variance To Ideal
          </el-button>

          <el-button class="toggle-btn" style="border-color: #606060" size="mini" :class="
            !is_variance_to_schedule_toggled ? 'inactive-toggle-btn' : ''
          " :icon="is_variance_to_schedule_toggled ? 'el-icon-close' : 'el-icon-check'"
           @click="is_variance_to_schedule_toggled = !is_variance_to_schedule_toggled">
            Variance To Schedule
          </el-button>

          <el-button v-if="checkCompany.is_sb_malaysia" class="toggle-btn" style="border-color: #606060" size="mini" :class="
            !is_variance_to_actual_toggled ? 'inactive-toggle-btn' : ''
          " :icon="is_variance_to_actual_toggled ? 'el-icon-close' : 'el-icon-check'"
           @click="is_variance_to_actual_toggled = !is_variance_to_actual_toggled">
            Variance To Actual
          </el-button>

          <el-button v-if="(checkCompany.is_sb_malaysia || checkCompany.is_bt)" class="toggle-btn" style="border-color: #606060" size="mini"
            :class="!is_sch_hrs_toggled ? 'inactive-toggle-btn' : ''"
            :icon="is_sch_hrs_toggled ? 'el-icon-close' : 'el-icon-check'"
            @click="is_sch_hrs_toggled = !is_sch_hrs_toggled">
            Scheduled Hours
          </el-button>

          <el-button v-if="(checkCompany.is_sb_malaysia || checkCompany.is_bt)" class="toggle-btn" style="border-color: #606060" size="mini"
            :class="!is_ach_hrs_toggled ? 'inactive-toggle-btn' : ''"
            :icon="is_ach_hrs_toggled ? 'el-icon-close' : 'el-icon-check'"
            @click="is_ach_hrs_toggled = !is_ach_hrs_toggled">
            Actual Hours
          </el-button>

          <el-button class="toggle-btn" style="border-color: #606060" size="mini"
            :class="!is_labour_cost_toggled ? 'inactive-toggle-btn' : ''"
            :icon="is_labour_cost_toggled ? 'el-icon-close' : 'el-icon-check'"
            @click="is_labour_cost_toggled = !is_labour_cost_toggled">
            Labour Cost
          </el-button>

          <el-button class="toggle-btn" style="border-color: #606060" size="mini"
            :class="!is_fte_toggled ? 'inactive-toggle-btn' : ''"
            :icon="is_fte_toggled ? 'el-icon-close' : 'el-icon-check'"
            @click="is_fte_toggled = !is_fte_toggled">
            FTE
          </el-button>

          <el-button class="toggle-btn" style="border-color: #606060" size="mini"
            :class="!is_pt_toggled ? 'inactive-toggle-btn' : ''" :icon="is_pt_toggled ? 'el-icon-close' : 'el-icon-check'"  @click="is_pt_toggled = !is_pt_toggled">
            PT%
          </el-button>

          <el-button class="toggle-btn" style="border-color: #606060" size="mini"
            :class="!is_gender_toggled ? 'inactive-toggle-btn' : ''" :icon="is_gender_toggled ? 'el-icon-close' : 'el-icon-check'"  @click="is_gender_toggled = !is_gender_toggled">
            Gender%
          </el-button>

          <el-button class="toggle-btn" style="border-color: #606060" size="mini"
            :class="!is_shift_complement_toggled ? 'inactive-toggle-btn' : ''"
            :icon="is_shift_complement_toggled ? 'el-icon-close' : 'el-icon-check'"
            @click="is_shift_complement_toggled = !is_shift_complement_toggled">
            Shift Complement
          </el-button>

          <el-button class="toggle-btn" style="border-color: #606060" size="mini"
            :class="!is_iplh_toggled ? 'inactive-toggle-btn' : ''"  :icon="is_iplh_toggled ? 'el-icon-close' : 'el-icon-check'" @click="is_iplh_toggled = !is_iplh_toggled">
            IPLH
          </el-button>

          <el-button class="toggle-btn" style="border-color: #606060" size="mini"
            :class="!is_tplh_toggled ? 'inactive-toggle-btn' : ''"  :icon="is_tplh_toggled ? 'el-icon-close' : 'el-icon-check'" @click="is_tplh_toggled = !is_tplh_toggled">
            TPLH
          </el-button>
        </el-button-group>
      </div>

      <div style="position: relative; background: #fff; overflow: hidden">
        <div v-loading="is_workforce_loading" class="dashboard-table-wrapper">
          <table v-if="tableData.length" class="dashboard-table">
            <thead>
              <tr>
                <th class="headcol" style="border: none; margin-top: 15px; height: 100%">
                  &nbsp;
                </th>

                <th v-if="is_actual_sales_toggled" colspan="1" style="min-width: 110px;">
                  <div class="bottom-border">SALES</div>
                </th>

                <th v-if="is_transactions_toggled" colspan="6">
                  <div class="bottom-border">TRANSACTIONS</div>
                </th>

                <th v-if="is_ipt_toggled && checkCompany.is_sb_malaysia" colspan="2">
                  <div class="bottom-border">IPT</div>
                </th>

                <th v-if="is_ideal_labour_hours_toggled"
                  :colspan="getUserDetails && getUserDetails.email != 'admin@wellnessforever.in' ? 3 : 1"
                  style="min-width: 160px;">
                  <div class="bottom-border">IDEAL LABOUR HOURS</div>
                </th>

                <th v-if="is_scheduled_labour_hours_toggled"
                  :colspan="getUserDetails && getUserDetails.email != 'admin@wellnessforever.in' ? 3 : 1"
                  style="min-width: 200px;">
                  <div class="bottom-border">SCHEDULED LABOUR HOURS</div>
                </th>

                <th v-if="is_actual_labour_hours_toggled"
                  :colspan="getUserDetails && getUserDetails.email != 'admin@wellnessforever.in' ? 3 : 1"
                  style="min-width: 200px;">
                  <div class="bottom-border">ACTUAL LABOUR HOURS</div>
                </th>

                <th v-if="is_wastage_hrs_toggled"
                  :colspan="getUserDetails && getUserDetails.email != 'admin@wellnessforever.in' ? 3 : 1"
                  style="min-width: 160px;">
                  <div class="bottom-border">WASTAGE HRS</div>
                </th>

                <th v-if="is_variance_to_ideal_toggled"
                  :colspan="getUserDetails && getUserDetails.email != 'admin@wellnessforever.in' ? 3 : 1"
                  style="min-width: 160px;">
                  <div class="bottom-border">VARIANCE TO IDEAL</div>
                </th>

                <th v-if="is_variance_to_actual_toggled && checkCompany.is_sb_malaysia" style="min-width: 200px;">
                  <div class="bottom-border">VARIANCE TO ACTUAL</div>
                </th>

                <th v-if="is_variance_to_schedule_toggled" style="min-width: 200px;">
                  <div class="bottom-border">VARIANCE TO SCHEDULED</div>
                </th>

                <th v-if="(checkCompany.is_sb_malaysia || checkCompany.is_bt) && is_sch_hrs_toggled" colspan="2">
                  <div class="bottom-border">SCHEDULED HOURS</div>
                </th>

                <th v-if="(checkCompany.is_sb_malaysia || checkCompany.is_bt) && is_ach_hrs_toggled" colspan="2">
                  <div class="bottom-border">ACTUAL HOURS</div>
                </th>

                <th v-if="is_labour_cost_toggled" colspan="4">
                  <div class="bottom-border">LABOUR COST</div>
                </th>

                <th v-if="is_fte_toggled" colspan="3">
                  <div class="bottom-border">FTE</div>
                </th>

                <th v-if="is_pt_toggled" colspan="2">
                  <div class="bottom-border">PT%</div>
                </th>

                <th v-if="is_gender_toggled" colspan="2">
                  <div class="bottom-border">GENDER%</div>
                </th>

                <th v-if="is_shift_complement_toggled" style="min-width: 200px">
                  <div class="bottom-border">SHIFT COMPLEMENT</div>
                </th>

                <th v-if="is_iplh_toggled" colspan="4">
                  <div class="bottom-border">IPLH</div>
                </th>

                <th v-if="is_tplh_toggled" colspan="4">
                  <div class="bottom-border">TPLH</div>
                </th>
              </tr>

              <tr>
                <th class="headcol" style="border: none; margin-top: 5px">
                  STORE NAME
                </th>

                <th v-if="is_actual_sales_toggled">ACTUAL</th>
                <!-- TRANSACTIONS -->
                <th v-if="is_transactions_toggled">PROJECTED</th>
                <th v-if="is_transactions_toggled">ADJUSTED</th>
                <th v-if="is_transactions_toggled">ACTUAL</th>
                <th v-if="is_transactions_toggled">PREVIOUS WEEK ADT</th>
                <th v-if="is_transactions_toggled" style="min-width: 200px">
                  FORECAST ACCURACY PERCENTAGE(PROJECTED)
                </th>
                <th v-if="is_transactions_toggled" style="min-width: 200px">
                  FORECAST ACCURACY PERCENTAGE(ADJUSTED)
                </th>

                <!-- IPT -->
                <th v-if="is_ipt_toggled && checkCompany.is_sb_malaysia">ACTUAL</th>
                <th v-if="is_ipt_toggled && checkCompany.is_sb_malaysia">FORECAST</th>

                <!-- IDEAL LABOUR HOURS -->
                <th
                  v-if="is_ideal_labour_hours_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'">
                  COVERAGE HOURS</th>
                <th
                  v-if="is_ideal_labour_hours_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'"
                  style="min-width: 170px">
                  NON COVERAGE HOURS
                </th>
                <th v-if="is_ideal_labour_hours_toggled" style="min-width: 100px">
                  TOTAL
                </th>

                <!-- SCHEDULED LABOUR HOURS -->
                <th
                  v-if="is_scheduled_labour_hours_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'">
                  COVERAGE HOURS</th>
                <th
                  v-if="is_scheduled_labour_hours_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'"
                  style="min-width: 170px">
                  NON COVERAGE HOURS
                </th>
                <th v-if="is_scheduled_labour_hours_toggled" style="min-width: 100px">
                  TOTAL
                </th>
                <!-- <th
                  v-if="is_scheduled_labour_hours_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'"
                  style="min-width: 100px">
                  OVERTIME
                </th> -->

                <!-- ACTUAL LABOUR HOURS -->
                <th
                  v-if="is_actual_labour_hours_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'">
                  COVERAGE HOURS</th>
                <th
                  v-if="is_actual_labour_hours_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'"
                  style="min-width: 170px">
                  NON COVERAGE HOURS
                </th>
                <th v-if="is_actual_labour_hours_toggled" style="min-width: 100px">
                  TOTAL
                </th>
                <!-- <th v-if="is_actual_labour_hours_toggled" style="min-width: 100px">
                  OVERTIME
                </th> -->

                <!-- WASTAGE HRS -->
                <th
                  v-if="is_wastage_hrs_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'">
                  COVERAGE HOURS</th>
                <th
                  v-if="is_wastage_hrs_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'"
                  style="min-width: 170px">
                  NON COVERAGE HOURS
                </th>
                <th v-if="is_wastage_hrs_toggled" style="min-width: 100px">
                  TOTAL
                </th>

                <!-- VARIANCE TO IDEAL -->
                <th
                  v-if="is_variance_to_ideal_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'">
                  COVERAGE HOURS</th>
                <th
                  v-if="is_variance_to_ideal_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'"
                  style="min-width: 170px">
                  NON COVERAGE HOURS
                </th>
                <th v-if="is_variance_to_ideal_toggled" style="min-width: 100px">
                  TOTAL
                </th>
                
                <!-- VARIANCE TO ACTUAL -->
                <th v-if="is_variance_to_actual_toggled && checkCompany.is_sb_malaysia">TOTAL</th>

                <!-- VARIANCE TO SCHEDULED -->
                <th v-if="is_variance_to_schedule_toggled">TOTAL</th>

                 <!-- Scheduled Hrs -->
                 <th v-if="(checkCompany.is_sb_malaysia || checkCompany.is_bt) && is_sch_hrs_toggled" style="min-width: 100px">
                  FULL TIME
                </th>
                <th v-if="(checkCompany.is_sb_malaysia || checkCompany.is_bt) && is_sch_hrs_toggled" style="min-width: 100px">
                  PART TIME
                </th>
                <!-- <th v-if="(checkCompany.is_sb_malaysia || checkCompany.is_bt) && is_sch_hrs_toggled" style="min-width: 100px">
                  OVERTIME
                </th> -->

                <!-- Actual Hrs -->
                <th v-if="(checkCompany.is_sb_malaysia || checkCompany.is_bt) && is_ach_hrs_toggled" style="min-width: 100px">
                  FULL TIME
                </th>
                <th v-if="(checkCompany.is_sb_malaysia || checkCompany.is_bt) && is_ach_hrs_toggled" style="min-width: 100px">
                  PART TIME
                </th>
                <!-- <th v-if="(checkCompany.is_sb_malaysia || checkCompany.is_bt) && is_ach_hrs_toggled" style="min-width: 100px">
                  OVERTIME
                </th> -->

                <!-- LABOUR COST -->
                <!-- <th v-if="is_labour_cost_toggled" style="min-width: 100px">
                  TARGET
                </th> -->
                <th v-if="is_labour_cost_toggled" style="min-width: 100px">
                  SCHEDULED
                </th>
                <th v-if="is_labour_cost_toggled" style="min-width: 100px">
                  ACTUAL
                </th>
                <th v-if="is_labour_cost_toggled" style="min-width: 170px">
                  SCHEDULED COL%
                </th>
                <th v-if="is_labour_cost_toggled" style="min-width: 170px">
                  ACTUAL COL%
                </th>

                <!-- FTE -->
                <th v-if="is_fte_toggled" style="min-width: 100px">
                  SCHEDULED
                </th>
                <th v-if="is_fte_toggled" style="min-width: 170px">
                  IDEAL
                </th>
                <th v-if="is_fte_toggled" style="min-width: 170px">
                  ACTUAL
                </th>

                <!-- PT% -->
                <th v-if="is_pt_toggled" style="min-width: 100px">PART TIME</th>
                <th v-if="is_pt_toggled" style="min-width: 100px">FULL TIME</th>

                <!-- GENDER% -->
                <th v-if="is_gender_toggled" style="min-width: 100px">MALE</th>
                <th v-if="is_gender_toggled" style="min-width: 100px">
                  FEMALE
                </th>

                <!-- SHIFT COMPLEMENT -->
                <th v-if="is_shift_complement_toggled">&nbsp;</th>

                <!-- IPLH -->
                <th v-if="is_iplh_toggled">SCHEDULE</th>
                <th v-if="is_iplh_toggled">ACTUAL</th>
                <th v-if="is_iplh_toggled">TARGET</th>
                <th v-if="is_iplh_toggled">ACHIEVEMENT</th>

                <!-- TPLH -->
                <th v-if="is_tplh_toggled">SCHEDULE</th>
                <th v-if="is_tplh_toggled">ACTUAL</th>
                <th v-if="is_tplh_toggled">TARGET</th>
                <th v-if="is_tplh_toggled">ACHIEVEMENT</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(data, data_index) in tableData" :key="data_index">
                <!-- store name -->
                <td class="headcol capitalize" :style="[data.name == 'Consolidated' ? { fontWeight: 'bold' } : {}]"
                  @click="getEmployeeLabourCost(data.name)">
                  <div
                    :style="[basics == 'outlet' && data.name != 'Consolidated' ? { textDecoration: 'underline', color: '#4ba3ff', cursor: 'pointer' } : {}]"
                    style="width: fit-content">
                    <el-tooltip :content="data.name" placement="top" effect="light">
                      <p class="ellipsis cursor-pointer">{{ data.name }}</p>
                    </el-tooltip>
                    <!-- {{ data.name }} -->
                  </div>
                </td>

                <td v-if="is_actual_sales_toggled">{{ data.sale_amount }}</td>
                <!-- TRANSACTIONS -->
                <td v-if="is_transactions_toggled">
                  {{ data.forecast_transaction }}
                </td>
                <td v-if="is_transactions_toggled">
                  {{ data.adjusted_forecast_transaction }}
                </td>
                <td v-if="is_transactions_toggled">
                  {{ data.actual_transactions }}
                </td>
                <td v-if="is_transactions_toggled">
                  {{ data.actual_transactions_prev_week ? data.actual_transactions_prev_week : '-' }}
                </td>
                <td v-if="is_transactions_toggled">{{ data.accuracy }} %</td>
                <td v-if="is_transactions_toggled">
                  {{ data.adjusted_accuracy }} %
                </td>

                <!-- IPT && checkCompany.is_sb_malaysia -->
                <td v-if="is_ipt_toggled && checkCompany.is_sb_malaysia">
                  {{ data.actual_ipt ? data.actual_ipt : '-' }}
                </td>
                <td v-if="is_ipt_toggled && checkCompany.is_sb_malaysia">
                  {{ data.forecast_ipt ? data.forecast_ipt : '-' }}
                </td>

                <!-- IDEAL LABOUR HOURS -->
                <td
                  v-if="is_ideal_labour_hours_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'">
                  {{ data.ideal_coverage_hours }}
                </td>
                <td
                  v-if="is_ideal_labour_hours_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'">
                  {{ data.ideal_non_coverage_hours }}
                </td>
                <td v-if="is_ideal_labour_hours_toggled">
                  {{ data.total_ideal_labour_hours }}
                </td>

                <!-- SCHEDULED LABOUR HOURS -->
                <td
                  v-if="is_scheduled_labour_hours_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'">
                  {{ data.sheduled_coverage_hours }}
                </td>
                <td
                  v-if="is_scheduled_labour_hours_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'">
                  {{ data.sheduled_non_coverage_hours }}
                </td>
                <td v-if="is_scheduled_labour_hours_toggled">
                  {{ data.total_sheduled_labour_hours }}
                </td>
                <!-- <td
                  v-if="is_scheduled_labour_hours_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'">
                  {{ data.scheduled_overtime_cost }}
                </td> -->

                <!-- ACTUAL LABOUR HOURS -->
                <td
                  v-if="is_actual_labour_hours_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'">
                  {{ data.actual_coverage_hours }}
                </td>
                <td
                  v-if="is_actual_labour_hours_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'">
                  {{ data.actual_non_coverage_hours }}
                </td>
                <td v-if="is_actual_labour_hours_toggled">
                  {{ data.actual_labour_hours }}
                </td>
                <!-- <td v-if="is_actual_labour_hours_toggled">
                  {{ data.actual_overtime_cost }}
                </td> -->

                <!-- WASTAGE HRS -->
                <td
                  v-if="is_wastage_hrs_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'">
                  {{ data.wastage_coverage_hours }}
                </td>
                <td
                  v-if="is_wastage_hrs_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'">
                  {{ data.wastage_non_coverage_hours }}
                </td>
                <td v-if="is_wastage_hrs_toggled">
                  {{ data.total_wastage_labour_hours }}
                </td>

                <!-- VARIANCE TO IDEAL -->
                <td
                  v-if="is_variance_to_ideal_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'">
                  {{ data.var_to_idl_coverage_hours }} %
                </td>
                <td
                  v-if="is_variance_to_ideal_toggled && getUserDetails && getUserDetails.email != 'admin@wellnessforever.in'">
                  {{ data.var_to_idl_non_coverage_hours }} %
                </td>
                <td v-if="is_variance_to_ideal_toggled">
                  {{ data.var_to_idl_total }} %
                </td>

                <!-- VARIANCE TO ACTUAL -->
                <td v-if="is_variance_to_actual_toggled && checkCompany.is_sb_malaysia">
                  {{ data.var_to_actual_total ? data.var_to_actual_total : '0' }} %
                </td>

                <!-- VARIANCE TO SCHEDULED -->
                <td v-if="is_variance_to_schedule_toggled">
                  {{ data.vairance_to_shedule }} %
                </td>

                <!-- Scheduled Hrs -->
                <th v-if="(checkCompany.is_sb_malaysia || checkCompany.is_bt) && is_sch_hrs_toggled">
                  {{ data.total_sheduled_labour_hours_ft ? data.total_sheduled_labour_hours_ft : '-' }}
                </th>
                <th v-if="(checkCompany.is_sb_malaysia || checkCompany.is_bt) && is_sch_hrs_toggled">
                  {{ data.total_sheduled_labour_hours_pt ? data.total_sheduled_labour_hours_pt : '-' }}
                </th>
                <!-- <th v-if="(checkCompany.is_sb_malaysia || checkCompany.is_bt) && is_sch_hrs_toggled">
                  {{ data.scheduled_overtime ? data.scheduled_overtime : '-' }}
                </th> -->

                <!-- Actual Hrs -->
                <th v-if="(checkCompany.is_sb_malaysia || checkCompany.is_bt) && is_ach_hrs_toggled">
                  {{ data.actual_labour_hours_ft ? data.actual_labour_hours_ft : '-' }}
                </th>
                <th v-if="(checkCompany.is_sb_malaysia || checkCompany.is_bt) && is_ach_hrs_toggled">
                  {{ data.actual_labour_hours_pt ? data.actual_labour_hours_pt : '-' }}
                </th>
                <!-- <th v-if="(checkCompany.is_sb_malaysia || checkCompany.is_bt) && is_ach_hrs_toggled">
                  {{ data.actual_overtime ? data.actual_overtime : '-' }}
                </th> -->

                <!-- LABOUR COST -->
                <!-- <td v-if="is_labour_cost_toggled">
                  {{ data.target_lc ? data.target_lc : "-" }}
                </td> -->
                <td v-if="is_labour_cost_toggled">
                  {{ data.scheduled_lc ? data.scheduled_lc : "-" }}
                </td>
                <td v-if="is_labour_cost_toggled">
                  {{ data.actual_lc ? data.actual_lc : "-" }}
                </td>
                <!-- <td v-if="is_labour_cost_toggled">
                  {{ data.tva_lc_var ? data.tva_lc_var : "-" }}
                </td> -->
                <!-- <td v-if="is_labour_cost_toggled">
                  {{ data.sva_lc_var ? data.sva_lc_var : "-" }}
                </td> -->
                <td v-if="is_labour_cost_toggled">
                  {{ data.sch_lc_act_sales_percentage ? data.sch_lc_act_sales_percentage : "-" }}
                </td>
                <td v-if="is_labour_cost_toggled">
                  {{ data.actual_lc_percentage ? data.actual_lc_percentage : "-" }}
                </td>

                <!-- FTE -->
                <td v-if="is_fte_toggled">
                  {{ data.planned_manpower ? data.planned_manpower : "-" }}
                </td>
                <td v-if="is_fte_toggled">
                  {{ data.projected_man_power ? data.projected_man_power : "-" }}
                </td>
                <td v-if="is_fte_toggled">
                  {{ data.actual_manpower ? data.actual_manpower : "-" }}
                </td>

                <!-- PT% -->
                <td v-if="is_pt_toggled">{{ data.part_time_per }} %</td>
                <td v-if="is_pt_toggled">{{ data.full_time_per }} %</td>

                <!-- GENDER% -->
                <td v-if="is_gender_toggled">{{ data.male_per }} %</td>
                <td v-if="is_gender_toggled">{{ data.female_per }} %</td>

                <!-- SHIFT COMPLEMENT -->
                <td v-if="is_shift_complement_toggled">
                  {{ data.shift_compliment }}
                </td>

                <!-- IPLH -->
                <td v-if="is_iplh_toggled">{{ data.scheduled_iplh }}</td>
                <td v-if="is_iplh_toggled">{{ data.actual_iplh }}</td>
                <td v-if="is_iplh_toggled">{{ data.target_iplh }}</td>
                <td v-if="is_iplh_toggled">{{ data.achievement_iplh }}</td>

                <!-- TPLH -->
                <td v-if="is_tplh_toggled">{{ data.scheduled_tplh }}</td>
                <td v-if="is_tplh_toggled">{{ data.actual_tplh }}</td>
                <td v-if="is_tplh_toggled">{{ data.target_tplh }}</td>
                <td v-if="is_tplh_toggled">{{ data.achievement_tplh }}</td>
              </tr>
            </tbody>
          </table>

          <div v-else class="font-bold text-lg text-center p-4">
            No Data Found!
          </div>
        </div>
      </div>

      <div class="text-right">
        <div class="pagination pt-2 pb-2 text-right">
          <el-pagination background :current-page.sync="pageInfo.currentPage" :page-sizes="[5, 10]"
            :page-size.sync="pageInfo.pageSize" layout="sizes, prev, pager, next" :total="pageInfo.count"
            @size-change="handlePageSizeChange" @current-change="handlePageInfoChange" />
        </div>
      </div>
    </div>

    <div v-else class="el-card h-full">
      <el-empty description="Sorry, we couldn’t find data for the selected dates. Please select a different date range and try again."></el-empty>
    </div>

    <el-dialog :visible.sync="transaction_dialog_visible" :close-on-click-modal="true" width="95%" top="0"
      custom-class="customClass" :lock-scroll="true" :show-close="true">
      <div class="tab" style="height: 100vh;">
        <el-card class="box-card">
          <div>
            <el-button icon="el-icon-arrow-left" type="warning" style="width: auto; background: #e29d5a" size="mini"
              @click="transaction_dialog_visible = false">
              Back
            </el-button>
          </div>

          <div class="flex justify-between mt-8">
            <div class="flex justify-between items-center">
              <div style="text-transform: uppercase; font-weight: bold; font-size: 14px; margin-top: 25px;">
                {{ selected_store_name }}
              </div>

              <div class="ml-10">
                <p class="lable text-xs font-bold mb-1">Report</p>
                <el-select v-model="report_type" style="max-width: 300px" placeholder="Select"
                  @change="getDateByReportType('LABOUR_WISE_PLANNING')">
                  <el-option v-for="(item, index) in viewList" :key="index" :value="item.id" :label="item.name">
                    {{ item.name }}
                  </el-option>
                </el-select>
              </div>

              <div class="ml-10">
                <p class="lable text-xs font-bold mb-1">From</p>
                <el-date-picker v-model="report_from_date" type="date" style="max-width: 170px" placeholder="Pick a day"
                  :picker-options="{ firstDayOfWeek: 1 }" :disabled="report_type != 'wfr'">
                </el-date-picker>
              </div>

              <div class="ml-10">
                <p class="lable text-xs font-bold mb-1">To</p>
                <el-date-picker v-model="report_to_date" type="date" style="max-width: 170px" placeholder="Pick a day"
                  :picker-options="{ firstDayOfWeek: 1 }" :disabled="report_type != 'wfr'">
                </el-date-picker>
              </div>

              <div class="mt-4 ml-10">
                <el-button size="small" class="toggle-btn" style="min-width: 90px; height: 35px"
                  @click="getCommonLabourCostAndHours()">Go</el-button>
              </div>
            </div>

            <div class="mt-4">
              <el-button size="mini" type="warning" plain :loading="is_all_day_csv_download_inprogress"
                @click="exportToCsv('datewise_download')">CSV <i class="el-icon-download"></i></el-button>
            </div>
          </div>
        </el-card>

        <el-card class="box-card mt-4">
          <div class="employee-cost-hr-table mt-2">
            <table v-loading="is_labour_cost_details_loading">
              <thead>
                <tr>
                  <th style="width: 8%;">DATE</th>

                  <th style="width: 10%;">
                    <div class="bottom-border">TARGET</div>
                  </th>

                  <th style="width: 23%;">
                    <div class="bottom-border">SCHEDULED</div>
                  </th>

                  <th style="width: 23%;">
                    <div class="bottom-border">ACTUAL</div>
                  </th>

                  <th style="width: 18%;">
                    <div class="bottom-border">VARIANCE HRS</div>
                  </th>

                  <th style="width: 18%;">
                    <div class="bottom-border">VARIANCE COST</div>
                  </th>
                </tr>

                <tr style="border-bottom: 1px solid #dedede">
                  <th style="width: 8%;">&nbsp;</th>

                  <!-- target section -->
                  <th style="width: 5%;">HRS</th>
                  <th style="width: 5%;">COST</th>

                  <!-- scheduled section -->
                  <th style="width: 5%;">HRS</th>
                  <th style="width: 5%;">COST</th>
                  <th style="width: 4%;">MEALS</th>
                  <th style="width: 9%;">
                    TOTAL COST

                    <i v-if="scheduled_total_cost_filter_by_descending_order_of_transaction"
                      @click="scheduledTotalCostByAscendingOrderForTransactionTable()"
                      class="el-icon-caret-bottom ml-1 cursor-pointer text-sm"></i>

                    <i v-if="scheduled_total_cost_filter_by_ascending_order_of_transaction"
                      @click="scheduledTotalCostByDescendingOrderForTransactionTable()"
                      class="el-icon-caret-top ml-1 cursor-pointer text-sm"></i>
                  </th>

                  <!-- actual section -->
                  <th style="width: 5%;">HRS</th>
                  <th style="width: 5%;">COST</th>
                  <th style="width: 4%;">MEALS</th>
                  <th style="width: 9%;">
                    TOTAL COST

                    <i v-if="actual_total_cost_filter_by_descending_order_of_transaction"
                      @click="actualTotalCostByAscendingOrderForTransactionTable()"
                      class="el-icon-caret-bottom ml-1 cursor-pointer text-sm"></i>

                    <i v-if="actual_total_cost_filter_by_ascending_order_of_transaction"
                      @click="actualTotalCostByDescendingOrderForTransactionTable()"
                      class="el-icon-caret-top ml-1 cursor-pointer text-sm"></i>
                  </th>

                  <!-- variance hrs -->
                  <th title="Target vs Actual" style="width: 9%;">
                    TGT. vs ACT.
                  </th>
                  <th title="Scheduled vs Actual" style="width: 9%;">
                    SCH. vs ACT.
                  </th>

                  <!-- variance cost -->
                  <th title="Target vs Actual" style="width: 9%;">
                    TGT. vs ACT.
                  </th>
                  <th title="Scheduled vs Actual" style="width: 9%;">
                    SCH. vs ACT.
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(item, item_index) in labour_cost_table_details.consolidated" :key="item_index"
                  style="border-bottom: 1px solid #ddd;">
                  <td style="width: 8%;" class="font-bold">Consolidated</td>

                  <!-- target section -->
                  <td style="width: 5%;" class="font-bold">-</td>
                  <td style="width: 5%;" class="font-bold">{{ item.target_lc }}</td>

                  <!-- scheduled section -->
                  <td style="width: 5%;" class="font-bold">{{ item.scheduled_hours }}</td>
                  <td style="width: 5%;" class="font-bold">{{ item.scheduled_lc }}</td>
                  <td style="width: 4%;" class="font-bold">{{ item.scheduled_meals_cost }}</td>
                  <td style="width: 9%;" class="font-bold">{{ item.scheduled_total_cost }}</td>

                  <!-- actual section -->
                  <td style="width: 5%;" class="font-bold">{{ item.actual_hours }}</td>
                  <td style="width: 5%;" class="font-bold">{{ item.actual_lc }}</td>
                  <td style="width: 4%;" class="font-bold">{{ item.actual_meals_cost }}</td>
                  <td style="width: 9%;" class="font-bold">{{ item.actual_total_cost }}</td>

                  <!-- variance hrs -->
                  <td style="width: 9%;" class="font-bold">-</td>
                  <td style="width: 9%;" class="font-bold">{{ item.sva_hour_var }}</td>

                  <!-- variance cost -->
                  <td style="width: 9%;" class="font-bold">{{ item.tva_lc_var }}</td>
                  <td style="width: 9%;" class="font-bold">{{ item.sva_lc_var }}</td>
                </tr>

                <tr v-for="(date, date_index) in labour_cost_table_details.date_consolidated"
                  :key="date_index + new Date().getTime()" style="border-bottom: 1px solid #ddd;">
                  <td style="color: #4ba3ff; width: 8%; cursor: pointer;"
                    @click="getEmployeeLabourCostAndHours(date.for_date)">{{ date.for_date }}</td>

                  <td style="width: 5%;">-</td>
                  <td style="width: 5%;">{{ date.target_lc }}</td>

                  <!-- scheduled section -->
                  <td style="width: 5%;">{{ date.scheduled_hours }}</td>
                  <td style="width: 5%;">{{ date.scheduled_lc }}</td>
                  <td style="width: 4%;">{{ date.scheduled_meals_cost }}</td>
                  <td style="width: 9%;">{{ date.scheduled_total_cost }}</td>

                  <!-- actual section -->
                  <td style="width: 5%;">{{ date.actual_hours }}</td>
                  <td style="width: 5%;">{{ date.actual_lc }}</td>
                  <td style="width: 4%;">{{ date.actual_meals_cost }}</td>
                  <td style="width: 9%;">{{ date.actual_total_cost }}</td>

                  <!-- variance hrs -->
                  <td style="width: 9%;">-</td>
                  <td style="width: 9%;">{{ date.sva_hour_var }}</td>

                  <!-- variance cost -->
                  <td style="width: 9%;">{{ date.tva_lc_var }}</td>
                  <td style="width: 9%;">{{ date.sva_lc_var }}</td>
                </tr>
              </tbody>
            </table>

            <div
              v-if="!labour_cost_table_details.consolidated.length && !labour_cost_table_details.date_consolidated.length && !is_labour_cost_details_loading"
              style="text-align: center; font-size: 14px; font-weight: 600; color: #e29d5a; padding: 15px;">
              No data available
            </div>
          </div>
        </el-card>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialog_visible" :close-on-click-modal="true" width="95%" top="0"
      custom-class="customClass" :lock-scroll="true" :show-close="true">
      <div class="tab" style="height: 100vh;">
        <el-card class="box-card">
          <div>
            <el-button icon="el-icon-arrow-left" type="warning" style="width: auto; background: #e29d5a" size="mini"
              @click="dialog_visible = false">
              Back
            </el-button>
          </div>

          <!-- <div class="flex justify-between mt-8">
            <div class="flex justify-between items-center">
              <div
                style="
                  text-transform: uppercase;
                  font-weight: bold;
                  font-size: 14px;
                  margin-top: 25px;
                "
              >
                {{ selected_store_name }}
              </div>

              <div style="margin-left: 150px">
                <p class="lable text-xs font-bold mb-1">Report</p>
                <el-select
                  v-model="report_type"
                  style="max-width: 300px"
                  placeholder="Select"
                  @change="getDateByReportType('LABOUR_WISE_PLANNING')"
                >
                  <el-option
                    v-for="(item, index) in viewList"
                    :key="index"
                    :value="item.id"
                    :label="item.name"
                  >
                    {{ item.name }}
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="flex items-center">
              <div class="mr-10">
                <p class="lable text-xs font-bold mb-1">From</p>
                <el-date-picker
                  v-model="report_from_date"
                  type="date"
                  style="max-width: 170px"
                  placeholder="Pick a day"
                  :picker-options="{ firstDayOfWeek: 1 }"
                  :disabled="report_type != 'wfr'"
                >
                </el-date-picker>
              </div>

              <div class="mr-10">
                <p class="lable text-xs font-bold mb-1">To</p>
                <el-date-picker
                  v-model="report_to_date"
                  type="date"
                  style="max-width: 170px"
                  placeholder="Pick a day"
                  :picker-options="{ firstDayOfWeek: 1 }"
                  :disabled="report_type != 'wfr'"
                >
                </el-date-picker>
              </div>

              <div class="mt-4">
                <el-button
                  size="small"
                  class="toggle-btn"
                  style="min-width: 90px; height: 35px"
                  @click="getCommonLabourCostAndHours()"
                  >Go</el-button
                >
              </div>
            </div>
          </div> -->
          <div class="flex items-center mt-8">
            <div style="text-transform: uppercase; font-weight: bold; font-size: 14px;">
              {{ selected_store_name }}

              <span style="color: #c2c2c2;">({{ moment(selected_date).format('DD MMM YYYY, ddd') }})</span>
            </div>

            <el-input v-model="search_emp_name" placeholder="Search By Employee" prefix-icon="el-icon-search"
              style="width: 350px; margin-left: 15px;">
            </el-input>

            <el-button size="mini" type="warning" plain class="ml-2" style="margin-left: auto;">CSV <i
                class="el-icon-download" :loading="is_per_day_csv_download_inprogress"
                @click="exportToCsv('employee_download')"></i>
            </el-button>
          </div>
        </el-card>

        <el-card class="box-card mt-4" style="height: 100%;">
          <div class="employee-cost-hr-table mt-2">
            <table v-loading="is_employee_cost_details_loading">
              <thead>
                <tr>
                  <th style="width: 10%;">EMPLOYEE</th>

                  <th style="width: 10%;">
                    <div class="bottom-border">TARGET</div>
                  </th>

                  <th style="width: 30%;">
                    <div class="bottom-border">SCHEDULED</div>
                  </th>

                  <th style="width: 30%;">
                    <div class="bottom-border">ACTUAL</div>
                  </th>

                  <th style="width: 10%;">
                    <div>&nbsp;</div>
                  </th>

                  <th style="width: 10%;">
                    <div>&nbsp;</div>
                  </th>
                </tr>

                <tr style="border-bottom: 1px solid #dedede">
                  <th style="width: 10%;">&nbsp;</th>

                  <!-- target section -->
                  <th style="width: 5%;">HRS</th>
                  <th style="width: 5%;">COST</th>

                  <!-- scheduled section -->
                  <th style="width: 8%;">TIME</th>
                  <th style="width: 6%;">HRS</th>
                  <th style="width: 6%;">COST</th>
                  <th style="width: 4%;">MEALS</th>
                  <th style="width: 6%;">
                    TOTAL COST

                    <i v-if="scheduled_total_cost_filter_by_descending_order"
                      @click="scheduledTotalCostByAscendingOrder()"
                      class="el-icon-caret-bottom ml-1 cursor-pointer text-sm"></i>

                    <i v-if="scheduled_total_cost_filter_by_ascending_order"
                      @click="scheduledTotalCostByDescendingOrder()"
                      class="el-icon-caret-top ml-1 cursor-pointer text-sm"></i>
                  </th>

                  <!-- actual section -->
                  <th style="width: 8%;">TIME</th>
                  <th style="width: 6%;">HRS</th>
                  <th style="width: 6%;">COST</th>
                  <th style="width: 4%;">MEALS</th>
                  <th style="width: 6%;">
                    TOTAL COST

                    <i v-if="actual_total_cost_filter_by_descending_order" @click="actualTotalCostByAscendingOrder()"
                      class="el-icon-caret-bottom ml-1 cursor-pointer text-sm"></i>

                    <i v-if="actual_total_cost_filter_by_ascending_order" @click="actualTotalCostByDescendingOrder()"
                      class="el-icon-caret-top ml-1 cursor-pointer text-sm"></i>
                  </th>

                  <!-- remarks -->
                  <th style="width: 10%;">
                    REMARKS
                  </th>

                  <!-- comments -->
                  <th style="width: 10%;">
                    COMMENT
                  </th>
                </tr>
              </thead>

              <tbody class="consolidated-row">
                <tr v-for="(item, item_index) in employee_cost_table_details.consolidated"
                  :key="item_index + Math.random()">
                  <td class="font-bold" style="color: #000; width: 10%; font-size: 10px">
                    CONSOLIDATED
                  </td>

                  <!-- target section -->
                  <!-- <td class="font-bold" style="color: #000;">
                    -
                  </td>
                  <td class="font-bold" style="color: #000">
                    {{ item.target_lc }}
                  </td> -->
                  <td class="font-bold" style="color: #000; width: 5%;">
                    -
                  </td>
                  <td class="font-bold" style="color: #000; width: 5%;">
                    {{ item.target_lc }}
                  </td>

                  <!-- scheduled section -->
                  <!-- <td class="font-bold" style="color: #000">
                    {{ item.scheduled_hours }}
                  </td>
                  <td class="font-bold" style="color: #000">
                    {{ item.scheduled_lc }}
                  </td>
                  <td class="font-bold" style="color: #000">
                    {{ item.scheduled_meals_cost }}
                  </td>
                  <td class="font-bold" style="color: #000">
                    {{ item.scheduled_overtime_cost }}
                  </td>
                  <td class="font-bold" style="color: #000">
                    {{ item.scheduled_total_cost }}
                  </td> -->
                  <td class="font-bold" style="color: #000; width: 8%;">
                    -
                  </td>
                  <td class="font-bold" style="color: #000; width: 6%;">
                    {{ item.scheduled_hours }}
                  </td>
                  <td class="font-bold" style="color: #000; width: 6%;">
                    {{ item.scheduled_lc }}
                  </td>
                  <td class="font-bold" style="color: #000; width: 4%;">
                    {{ item.scheduled_meals_cost }}
                  </td>
                  <td class="font-bold" style="color: #000; width: 6%;">
                    {{ item.scheduled_total_cost }}
                  </td>

                  <!-- actual section -->
                  <!-- <td class="font-bold" style="color: #000">
                    {{ item.actual_hours }}
                  </td>
                  <td class="font-bold" style="color: #000">
                    {{ item.actual_lc }}
                  </td>
                  <td class="font-bold" style="color: #000">
                    {{ item.actual_meals_cost }}
                  </td>
                  <td class="font-bold" style="color: #000">
                    {{ item.actual_overtime_cost }}
                  </td>
                  <td class="font-bold" style="color: #000">
                    {{ item.actual_total_cost }}
                  </td> -->
                  <td class="font-bold" style="color: #000; width: 8%;">
                    -
                  </td>
                  <td class="font-bold" style="color: #000; width: 6%;">
                    {{ item.actual_hours }}
                  </td>
                  <td class="font-bold" style="color: #000; width: 6%;">
                    {{ item.actual_lc }}
                  </td>
                  <td class="font-bold" style="color: #000; width: 4%;">
                    {{ item.actual_meals_cost }}
                  </td>
                  <td class="font-bold" style="color: #000; width: 6%;">
                    {{ item.actual_total_cost }}
                  </td>

                  <!-- remarks -->
                  <td style="color: #000; width: 10%;">
                    &nbsp;
                  </td>

                  <!-- comments -->
                  <td style="color: #000; width: 10%;">
                    &nbsp;
                  </td>
                </tr>

                <tr v-for="(department, department_index) in filteredDepartmentList" :key="department_index"
                  style="background: #f2f2f2; border-bottom: 1px solid #ddd;">
                  <td class="capitalize" style="color: #000; width: 10%; font-size: 10px;">
                    {{ department.name }}
                  </td>

                  <!-- target section -->
                  <td style="color: #000; width: 5%;">
                    -
                  </td>
                  <td style="color: #000; width: 5%;">
                    {{ department.target_lc }}
                  </td>

                  <!-- scheduled section -->
                  <td style="color: #000; width: 8%;">
                    -
                  </td>
                  <td style="color: #000; width: 6%;">
                    {{ department.scheduled_hours }}
                  </td>
                  <td style="color: #000; width: 6%;">
                    {{ department.scheduled_lc }}
                  </td>
                  <td style="color: #000; width: 4%;">
                    {{ department.scheduled_meals_cost }}
                  </td>
                  <td style="color: #000; width: 6%;">
                    {{ department.scheduled_total_cost }}
                  </td>

                  <!-- actual section -->
                  <!-- <td style="color: #000">
                    {{ item.actual_hours }}
                  </td>
                  <td style="color: #000">
                    {{ item.actual_lc }}
                  </td>
                  <td style="color: #000">
                    {{ item.actual_meals_cost }}
                  </td>
                  <td style="color: #000">
                    {{ item.actual_overtime_cost }}
                  </td>
                  <td style="color: #000">
                    {{ item.actual_total_cost }}
                  </td> -->
                  <td style="color: #000; width: 8%;">
                    -
                  </td>
                  <td style="color: #000; width: 6%;">
                    {{ department.actual_hours }}
                  </td>
                  <td style="color: #000; width: 6%;">
                    {{ department.actual_lc }}
                  </td>
                  <td style="color: #000; width: 4%;">
                    {{ department.actual_meals_cost }}
                  </td>
                  <td style="color: #000; width: 6%;">
                    {{ department.actual_total_cost }}
                  </td>

                  <!-- remarks -->
                  <td style="color: #000; width: 10%;">
                    &nbsp;
                  </td>

                  <!-- comments -->
                  <td style="color: #000; width: 10%;">
                    &nbsp;
                  </td>

                  <table class="employee-cost-hr-table" style="border: none; background: #fff;">
                    <tbody>
                      <tr v-for="(emp, emp_index) in department.employees" :key="emp_index + Math.random()"
                        style="border-bottom: 1px solid #ddd;">
                        <td style="width: 10%;">
                          <div>
                            <div style="color: #000;">{{ emp.name }}</div>
                            <div class="mt-1" style="color: #29b823;">{{ department.name }}</div>
                          </div>
                        </td>

                        <!-- target section -->
                        <td style="color: #000; width: 5%;">
                          -
                        </td>
                        <td style="color: #000; width: 5%;">
                          {{ emp.target_lc }}
                        </td>

                        <!-- scheduled section -->
                        <td style="color: #000; width: 8%;">
                          <div v-if="emp.scheduled_shift_start_time && emp.scheduled_shift_end_time">
                            {{ moment(emp.scheduled_shift_start_time).format('HH:mm') }} - {{
                                moment(emp.scheduled_shift_end_time).format('HH:mm')
                            }}
                          </div>

                          <div v-else>-</div>
                        </td>
                        <td style="color: #000; width: 6%;">
                          {{ emp.scheduled_hours }}
                        </td>
                        <td style="color: #000; width: 6%;">
                          {{ emp.scheduled_lc }}
                        </td>
                        <td style="color: #000; width: 4%;">
                          {{ emp.scheduled_meals_cost }}
                        </td>
                        <td style="color: #000; width: 6%;">
                          {{ emp.scheduled_total_cost }}
                        </td>

                        <td style="color: #000; width: 8%;">
                          <div v-if="emp.actual_shift_start_time && emp.actual_shift_end_time">
                            {{ moment(emp.actual_shift_start_time).format('HH:mm') }} - {{
                                moment(emp.actual_shift_end_time).format('HH:mm')
                            }}
                          </div>

                          <div v-else>-</div>
                        </td>
                        <td style="color: #000; width: 6%;">
                          {{ emp.actual_hours }}
                        </td>
                        <td style="color: #000; width: 6%;">
                          {{ emp.actual_lc }}
                        </td>
                        <td style="color: #000; width: 4%;">
                          {{ emp.actual_meals_cost }}
                        </td>
                        <td style="color: #000; width: 6%;">
                          {{ emp.actual_total_cost }}
                        </td>

                        <!-- remarks -->
                        <td style="width: 10%; flex-flow: column;">
                          <div v-for="(remark, remark_index) in emp.remarks" :key="remark_index + Math.random()">
                            <div class="mb-2 capitalize" :style="colorCodeForRemarks(remark)">{{ remark ?
                                formattedRemark(remark) : '-'
                            }}</div>
                          </div>
                        </td>

                        <!-- comments -->
                        <td style="width: 10%;">
                          <span style="color: #000;" v-if="emp.comments">
                            <el-popover placement="left" title="Tips" width="250" popper-class="text-sm" trigger="hover"
                              :content="emp.comments">

                              <div slot="reference" class="cursor-pointer ellipsis" style="width: 60px;">{{ emp.comments
                              }}</div>
                            </el-popover>
                          </span>

                          <span style="color: #e29d5a; cursor: pointer;" v-else
                            @click="editComment(emp, emp_index, department_index)">Add Comment</span>

                          <div class="ml-2" v-if="emp.comments">
                            <img src="../../../assets/images/edit.png"
                              style="cursor: pointer; display: block; min-width: 16px; max-width: 16px;"
                              @click="editComment(emp, emp_index, department_index)" />

                            <img src="../../../assets/images/delete-icon.png"
                              style="cursor: pointer; display: block; min-width: 16px; max-width: 16px;" class="mt-1"
                              @click="deleteComment(emp, emp_index, department_index)" />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </tr>
              </tbody>
            </table>

            <div
              v-if="!employee_cost_table_details.consolidated.length && !filteredDepartmentList.length && !is_employee_cost_details_loading"
              style="text-align: center; font-size: 14px; font-weight: 600; color: #e29d5a; padding: 15px;">
              No data available
            </div>
          </div>
        </el-card>
      </div>
    </el-dialog>

    <el-dialog title="Tip" :visible.sync="edit_comment_dialog_visible" width="40%">
      <div>
        <div style="padding: 10px">
          <el-input v-model="comment" type="textarea" :rows="2" resize="none" placeholder="Please input" size="small"
            style="width: 100%" :maxlength="280" :show-word-limit="true">
          </el-input>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="flex justify-end">
          <el-button type="submit" style="width: 100px;" class="toggle-btn" size="mini"
            @click="edit_comment_dialog_visible = false">
            Cancel
          </el-button>

          <el-button type="submit" style="width: 100px; margin-left: 10px;" class="toggle-btn" size="mini"
            :loading="is_comments_updating" @click="saveComment()">
            Save
          </el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { serverAddr, serverAddrForCSV, serverAddrForXLSX } from "../../../networkConfig";
import moment from "moment";
import { EventBus } from "../../../eventBus";
import BaseLocationsDropdown from "../../baseLocationsDD/BaseLocationsDD.vue";
import BaseLabourHoursGraph from "./BaseLabourHoursGraph.vue";
import BaseIplhGraph from "./BaseIplhGraph.vue";
import VarianceGraph from "./VarianceGraph.vue";
import BasePieChart from "./BasePieChart.vue";
import { forEach } from "lodash";

import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";
import domtoimage from "dom-to-image";
import LabourPlanningService from "../../../services/labourPalnningService";
import { mapActions } from "vuex";

export default {
  name: "WrokForceDashboard",

  components: {
    BaseLocationsDropdown,
    BaseLabourHoursGraph,
    BaseIplhGraph,
    VarianceGraph,
    BasePieChart,
  },

  data() {
    return {
      tableData: [],
      analyticsDataResponse: [],
      viewList: [
        // {
        // name: "Workforce",
        // id: "wfr",
        // isDisabled: false
        // },
        {
          name: "Week To Date",
          id: "wtd",
          isDisabled: false,
        },
        {
          name: "Month To Date",
          id: "mtd",
          isDisabled: false,
        },
        {
          name: "Year To Date",
          id: "ytd",
        },
        {
          name: "Custom Dates",
          id: "wfr",
        },
      ],
      view: "wtd",
      fromDate: "",
      toDate: moment(),
      //   toDate: moment(new Date(new Date().setDate(new Date().getDate() - 1))).format("YYYY-MM-DD"),
      basics: "outlet",

      report_type: "wtd",
      report_from_date: "",
      report_to_date: moment(),

      param: {
        // start_date: moment(this.fromDate).format("YYYY-MM-DD"),
        // end_date: moment(this.toDate).format("YYYY-MM-DD"),
        // view: "dashboard",
        // quickreport: this.view,
        // basics: "outlet",
      },
      filters: {
        countries: [],
        regions: [],
        subregions: [],
        outlets: [],
      },
      pageInfo: {
        currentPage: 1,
        pageSize: 5,
        count: 0,
      },
      consoleData: {},
      storeMappings: [],
      is_labour_cost_visible: true,
      is_pt_visible: true,
      is_gender_visible: true,
      is_shift_complement_visible: true,
      is_iplh_visible: true,
      is_tplh_visible: true,
      dialog_visible: false,
      transaction_dialog_visible: false,
      is_workforce_loading: false,

      labour_cost_table_details: {
        consolidated: [],
        date_consolidated: [],
      },
      employee_cost_table_details: {
        consolidated: [],
        department_consolidated: []
      },

      selected_store_name: "",
      selected_outlet: [],
      is_labour_cost_details_loading: false,
      is_employee_cost_details_loading: false,

      is_transactions_toggled: true,
      is_ipt_toggled: true,
      is_actual_sales_toggled: true,
      is_ideal_labour_hours_toggled: true,
      is_scheduled_labour_hours_toggled: true,
      is_actual_labour_hours_toggled: true,
      is_wastage_hrs_toggled: true,
      is_variance_to_ideal_toggled: true,
      is_labour_cost_toggled: true,
      is_sch_hrs_toggled: true,
      is_ach_hrs_toggled: true,
      is_fte_toggled: true,
      is_variance_to_schedule_toggled: true,
      is_variance_to_actual_toggled: true,
      is_pt_toggled: true,
      is_gender_toggled: true,
      is_shift_complement_toggled: true,
      is_iplh_toggled: true,
      is_tplh_toggled: true,
      datePickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        firstDayOfWeek: 1,
      },
      disabledStartDate: {
        disabledDate: (date) => {
          return date < this.fromDate;
        },
        firstDayOfWeek: 1,
      },
      firstDayOfWeek: {
        firstDayOfWeek: 1,
      },
      is_per_day_csv_download_inprogress: false,
      is_all_day_csv_download_inprogress: false,
      selectedLabourHrs: true,
      selectedIplh: true,
      is_csv_loading: false,
      edit_comment_dialog_visible: false,
      department_index: '',
      employee_index: '',
      comment: '',
      selected_date: '',
      is_comments_updating: false,
      search_emp_name: '',
      scheduled_total_cost_filter_by_descending_order: true,
      scheduled_total_cost_filter_by_ascending_order: false,
      actual_total_cost_filter_by_descending_order: true,
      actual_total_cost_filter_by_ascending_order: false,

      scheduled_total_cost_filter_by_descending_order_of_transaction: true,
      scheduled_total_cost_filter_by_ascending_order_of_transaction: false,
      actual_total_cost_filter_by_descending_order_of_transaction: true,
      actual_total_cost_filter_by_ascending_order_of_transaction: false,
      moment: moment,
      departmentsList: [],
      selectedDepartment: 'null',
      is_loading_wfd_data: false,
      show_wfd_data: false,
    };
  },

  computed: {
    checkCompany(){
      return JSON.parse(localStorage.getItem('check_company'));
    },
    filteredDepartmentList() {
      let department_list = JSON.parse(JSON.stringify(this.employee_cost_table_details.department_consolidated));

      if (this.search_emp_name.trim()) {
        let filter_list = [];
        let filtered_employees = [];

        department_list.forEach((e) => {
          e.employees.forEach((emp) => {
            if (emp.name.toLowerCase().includes(this.search_emp_name)) {
              filter_list = [];
              filtered_employees = [];

              // console.log(emp, e);
              filter_list.push(e);
              filtered_employees.push(emp);
            }
          });
        });

        for (let i = 0; i < filter_list.length; i++) {
          filter_list[i].employees = filtered_employees;
        }

        department_list = filter_list;

      } else {
        department_list = this.employee_cost_table_details.department_consolidated;
      }

      return department_list;
    },

    getUserDetails() {
      return this.$store.state.loginUserDetails;
    }
  },

  created() {
    this.getDateByReportType("DASHBOARD");

    // this.getTableData();
    this.consolidatedData();
    this.getStoreDepartmentsFunc();
  },

  methods: {
    ...mapActions("CommonStore",["addDownloadingReportCountAction", "removeDownloadingReportCountAction", "abortDownloadingReportCountAction"]),
    getStoreDepartmentsFunc(){
      let params = {
        outlet_id: 'b6b8e3a1-358a-4695-a6a9-4185b0e126f0'
      }
      LabourPlanningService.getStoreDepartments(params).then((res)=>{
        this.departmentsList = JSON.parse(res.data);
      }).catch((err)=>{
        console.error(err);
      });
    },
    scheduledTotalCostByDescendingOrderForTransactionTable() {
      this.scheduled_total_cost_filter_by_ascending_order_of_transaction = false;
      this.scheduled_total_cost_filter_by_descending_order_of_transaction = true;

      this.actual_total_cost_filter_by_ascending_order_of_transaction = false;
      this.actual_total_cost_filter_by_descending_order_of_transaction = true;

      this.labour_cost_table_details.date_consolidated.sort((a, b) => Number(b.scheduled_total_cost) - Number(a.scheduled_total_cost));
    },

    scheduledTotalCostByAscendingOrderForTransactionTable() {
      this.scheduled_total_cost_filter_by_descending_order_of_transaction = false;
      this.scheduled_total_cost_filter_by_ascending_order_of_transaction = true;

      this.actual_total_cost_filter_by_ascending_order_of_transaction = false;
      this.actual_total_cost_filter_by_descending_order_of_transaction = true;

      this.labour_cost_table_details.date_consolidated.sort((a, b) => Number(a.scheduled_total_cost) - Number(b.scheduled_total_cost));
    },

    actualTotalCostByDescendingOrderForTransactionTable() {
      this.actual_total_cost_filter_by_ascending_order_of_transaction = false;
      this.actual_total_cost_filter_by_descending_order_of_transaction = true;

      this.scheduled_total_cost_filter_by_ascending_order_of_transaction = false;
      this.scheduled_total_cost_filter_by_descending_order_of_transaction = true;

      this.labour_cost_table_details.date_consolidated.sort((a, b) => Number(b.actual_total_cost) - Number(a.actual_total_cost));
    },

    actualTotalCostByAscendingOrderForTransactionTable() {
      this.actual_total_cost_filter_by_descending_order_of_transaction = false;
      this.actual_total_cost_filter_by_ascending_order_of_transaction = true;

      this.scheduled_total_cost_filter_by_ascending_order_of_transaction = false;
      this.scheduled_total_cost_filter_by_descending_order_of_transaction = true;

      this.labour_cost_table_details.date_consolidated.sort((a, b) => Number(a.actual_total_cost) - Number(b.actual_total_cost));
    },

    // for employee transaction table
    scheduledTotalCostByDescendingOrder() {
      this.scheduled_total_cost_filter_by_ascending_order = false;
      this.scheduled_total_cost_filter_by_descending_order = true;

      this.actual_total_cost_filter_by_ascending_order = false;
      this.actual_total_cost_filter_by_descending_order = true;

      for (let i = 0; i < this.employee_cost_table_details.department_consolidated.length; i++) {
        // console.log('this.scheduled_total_cost_filter_by_descending_order');
        this.employee_cost_table_details.department_consolidated[i].employees.sort((a, b) => Number(b.scheduled_total_cost) - Number(a.scheduled_total_cost));
      }
    },

    scheduledTotalCostByAscendingOrder() {
      this.scheduled_total_cost_filter_by_descending_order = false;
      this.scheduled_total_cost_filter_by_ascending_order = true;

      this.actual_total_cost_filter_by_ascending_order = false;
      this.actual_total_cost_filter_by_descending_order = true;

      for (let i = 0; i < this.employee_cost_table_details.department_consolidated.length; i++) {
        // console.log('this.scheduled_total_cost_filter_by_descending_order');
        this.employee_cost_table_details.department_consolidated[i].employees.sort((a, b) => Number(a.scheduled_total_cost) - Number(b.scheduled_total_cost));
      }
    },

    actualTotalCostByDescendingOrder() {
      this.actual_total_cost_filter_by_ascending_order = false;
      this.actual_total_cost_filter_by_descending_order = true;

      this.scheduled_total_cost_filter_by_ascending_order = false;
      this.scheduled_total_cost_filter_by_descending_order = true;

      for (let i = 0; i < this.employee_cost_table_details.department_consolidated.length; i++) {
        // console.log('this.actual_total_cost_filter_by_descending_order');
        this.employee_cost_table_details.department_consolidated[i].employees.sort((a, b) => Number(b.actual_total_cost) - Number(a.actual_total_cost));
      }
    },

    actualTotalCostByAscendingOrder() {
      this.actual_total_cost_filter_by_descending_order = false;
      this.actual_total_cost_filter_by_ascending_order = true;

      this.scheduled_total_cost_filter_by_ascending_order = false;
      this.scheduled_total_cost_filter_by_descending_order = true;

      for (let i = 0; i < this.employee_cost_table_details.department_consolidated.length; i++) {
        // console.log('this.actual_total_cost_filter_by_descending_order');
        this.employee_cost_table_details.department_consolidated[i].employees.sort((a, b) => Number(a.actual_total_cost) - Number(b.actual_total_cost));
      }
    },

    colorCodeForRemarks(remark) {
      let style_obj = {};

      if (remark == 'ON-TIME') {
        style_obj = {
          color: '#29b823'
        }

      } else if (remark == 'INACTIVE' || remark == 'ABSENT' || remark.includes('Early Left By') || remark.includes('Late by') || remark.includes('Overtime By') || remark.includes('Early In By')) {
        style_obj = {
          color: '#d60918'
        }

      } else {
        style_obj = {
          color: '#000'
        }
      }

      return style_obj;
    },

    formattedRemark(remark) {
      let str = remark;

      if (remark) {
        str = str.toLowerCase();
      }

      return str;
    },

    changedLabourGraph(type) {
      if (type == "labour hrs") {
        this.selectedLabourHrs = true;
        let data = {
          name: "Labour Hours",
          data: [
            {
              name: "Ideal",
              actual: this.consoleData.total_ideal_labour_hours,
              ideal: this.consoleData.ideal_coverage_hours,
              scheduled: this.consoleData.ideal_non_coverage_hours,
            },
            {
              name: "Scheduled",
              actual: this.consoleData.total_sheduled_labour_hours,
              ideal: this.consoleData.sheduled_coverage_hours,
              scheduled: this.consoleData.sheduled_non_coverage_hours,
            },
            {
              name: "Actual",
              actual: this.consoleData.actual_labour_hours,
              ideal: this.consoleData.actual_coverage_hours,
              scheduled: this.consoleData.actual_non_coverage_hours,
            },
          ],
        };
        EventBus.$emit("reponseLabourHoursGraph", data);
      } else {
        this.selectedLabourHrs = false;
        let data = {
          name: "Labour Cost",
          data: [
            {
              name: "Scheduled",
              data: this.consoleData.scheduled_lc,
              percent: this.consoleData.sch_lc_act_sales_percentage
            },
            {
              name: "Actual",
              data: this.consoleData.actual_lc,
              percent: this.consoleData.actual_lc_percentage
            },
          ],
        };
        EventBus.$emit("reponseLabourHoursGraph", data);
      }
    },

    changedIplhGraph(type) {
      if (type == "IPLH") {
        this.selectedIplh = true;
        let iplhdata = {
          name: "IPLH",
          data: [
            {
              name: "Ideal",
              actual: this.consoleData.achievement_iplh,
              ideal: this.consoleData.actual_iplh,
              scheduled: this.consoleData.target_iplh,
              new_scheduled: this.consoleData.scheduled_iplh,
            },
          ],
        };
        EventBus.$emit("reponseIplhGraph", iplhdata);
      } else {
        this.selectedIplh = false;
        let tplhdata = {
          name: "TPLH",
          data: [
            {
              name: "Ideal",
              actual: this.consoleData.achievement_tplh,
              ideal: this.consoleData.actual_tplh,
              scheduled: this.consoleData.target_tplh,
              new_scheduled: this.consoleData.scheduled_tplh,
            },
          ],
        };
        EventBus.$emit("reponseIplhGraph", tplhdata);
      }
    },

    exportToCsv(csv_type) {
      // according to csv type displayed loader
      if (csv_type == "datewise_download") {
        this.is_all_day_csv_download_inprogress = true; //enabled loader
      } else {
        this.is_per_day_csv_download_inprogress = true; //enabled loader
      }

      var params = {
        start_date: moment(this.report_from_date).format("YYYY-MM-DD"),
        end_date: moment(this.report_to_date).format("YYYY-MM-DD"),
        // view: "dashboard",
        quickreport: this.view,
        csv_type: null,
        basics: null,
        filters: {
          outlets: [],
        },
      };

      params.filters.outlets.push(this.selected_outlet[0].id);

      if (csv_type == "datewise_download") {
        // params.quickreport = "per_day";
        params.csv_type = "datewise_download";
      } else {
        params.csv_type = "employee_download";
        params.for_date = moment(this.selected_date).format('YYYY-MM-DD');
        // params.quickreport = this.report_type == "wfr" ? null : this.report_type;
      }

      serverAddrForCSV
        .post(`/sheduling/reports/labour-cost/csv/`, params)
        .then((response) => {
          if (response.status == 200) {
            var data = response.data;

            let urlData = "data:text/csv;charset=UTF-8," + encodeURIComponent(data);

            var tempLink = document.createElement("a");
            tempLink.href = urlData;
            tempLink.setAttribute("download", `WorkforceReport.csv`);
            tempLink.click();
          }

          if (csv_type == "datewise_download") {
            this.is_all_day_csv_download_inprogress = false; //disabled loader
          } else {
            this.is_per_day_csv_download_inprogress = false; //disabled loader
          }
        })
        .catch((error) => {
          console.log(error);

          if (csv_type == "datewise_download") {
            this.is_all_day_csv_download_inprogress = false; //disabled loader
          } else {
            this.is_per_day_csv_download_inprogress = false; //disabled loader
          }
        });
    },

    // function to change from date by report type,,sent parametres DASHBOARD && LABOUR_WISE_PLANNING
    // DASHBOARD is when date is changed by main page & LABOUR_WISE_PLANNING is when date is changed by labour planning dialog
    getDateByReportType(lable) {
      var date = new Date(); // get current date

      if (lable == "LABOUR_WISE_PLANNING") {
        if (this.report_type == "wtd") {
          let first = date.getDate() - date.getDay();
          let firstDay = new Date(date.setDate(first + 1)).toUTCString();
          this.report_from_date = firstDay;
        } else if (this.report_type == "mtd") {
          let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
          this.report_from_date = firstDay;
          // var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        } else if (this.report_type == "ytd") {
          let firstDay = new Date(this.getCurrentFinancialYear(), 3, 1);
          this.report_from_date = firstDay;
        }
      } else if (lable == "DASHBOARD") {
        this.toDate = new Date();
        if (this.view == "wtd") {
          let first = date.getDate() - date.getDay();
          let firstDay = new Date(date.setDate(first + 1)).toUTCString();
          this.fromDate = firstDay;
        } else if (this.view == "mtd") {
          let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
          this.fromDate = firstDay;
          // var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        } else if (this.view == "ytd") {
          let firstDay = new Date(this.getCurrentFinancialYear(), 3, 1);
          this.fromDate = firstDay;
        } else {
          this.fromDate = null;
          this.toDate = null;
        }
      }
    },

    getCurrentFinancialYear() {
      var financial_year = "";
      var today = new Date();
      if (today.getMonth() + 1 <= 3) {
        financial_year = today.getFullYear() - 1;
      } else {
        financial_year = today.getFullYear();
      }
      return financial_year;
    },

    handlePageSizeChange(val) {
      this.pageInfo.pageSize = val;
      // this.getTableData();
      this.consolidatedData();
    },

    handlePageInfoChange(val) {
      this.pageInfo.currentPage = val;
      // this.getTableData();
      this.consolidatedData();
    },

    // async getTableData() {
    //   this.analyticsDataResponse = await this.applyFilters();
    //   this.is_workforce_loading = false; //disabled loader
    // },

    dropDownUpdate(update) {

      this.pageInfo = {
        currentPage: 1,
        pageSize: 5,
        count: 0,
      };
      this.filters = {
        countries: [],
        regions: [],
        subregions: [],
        outlets: [],
      };
      // this.param = [];
      // if (update.selected.length) {
      //   this.basics = update.basics;
      // } else {
      //   this.basics = "outlet";
      // }

      // Updated select box ui
      this.basics = "outlet";
      this.filters.outlets = update.map((e) => {
        return e;
      });


      // if (update.basics == "country") {
      //   this.filters.countries = update.selected.map((e) => {
      //     return e.id;
      //   });
      // } else if (update.basics == "region") {
      //   this.filters.regions = update.selected.map((e) => {
      //     return e.id;
      //   });
      // } else if (update.basics == "subregion") {
      //   this.filters.subregions = update.selected.map((e) => {
      //     return e.id;
      //   });
      // } else if (update.basics == "outlet") {
      //   this.filters.outlets = update.selected.map((e) => {
      //     return e.id;
      //   });
      // }
      //   this.applyFilters();
    },

    getOutletsMapping(analyticsDataResponse) {
      // this.tableData = [];
      // this.consoleData = [];
      if (
        analyticsDataResponse.results &&
        analyticsDataResponse.results.length
      ) {
        this.outlet_ids = analyticsDataResponse.results.map((obj) => {
          return Object.keys(obj)[0];
        });
      } else {
        this.outlet_ids = analyticsDataResponse.map((obj) => {
          return Object.keys(obj)[0];
        });
      }

      this.outlet_ids = this.outlet_ids.filter(
        (id) => id != "columns" && id != ""
      );

      return serverAddr
        .post("/common/name-mapping/", {
          basics: this.basics,
          id_list: this.outlet_ids,
        })
        .then((response) => {
          if (response.status == 200) {
            this.storeMappings = JSON.parse(response.data);
            let data = [];
            this.pageInfo.count = analyticsDataResponse.count;
            for (let i = 0; i < analyticsDataResponse.results.length; i++) {
              for (var key in analyticsDataResponse.results[i]) {
                for (var j = 0; j < this.storeMappings.length; j++) {
                  if (this.storeMappings[j].id == key) {
                    analyticsDataResponse.results[i][key].name =
                      this.storeMappings[j].name;
                  }
                }
              }
            }
            for (let i = 0; i < analyticsDataResponse.results.length; i++) {
              for (var key in analyticsDataResponse.results[i]) {
                let obj = {
                  name: analyticsDataResponse.results[i][key].name,
                  total_ideal_labour_hours:
                    analyticsDataResponse.results[i][key]
                      .total_ideal_labour_hours,
                  accuracy: analyticsDataResponse.results[i][key].accuracy,
                  adjusted_accuracy:
                    analyticsDataResponse.results[i][key].adjusted_accuracy,
                  adjusted_forecast_transaction:
                    analyticsDataResponse.results[i][key]
                      .adjusted_forecast_transaction,
                  forecast_transaction:
                    analyticsDataResponse.results[i][key].forecast_transaction,
                  actual_transactions:
                    analyticsDataResponse.results[i][key].actual_transactions,
                  actual_transactions_prev_week:
                    analyticsDataResponse.results[i][key].actual_transactions_prev_week,
                  actual_ipt:
                    analyticsDataResponse.results[i][key].actual_ipt,
                  forecast_ipt:
                    analyticsDataResponse.results[i][key].forecast_ipt,
                  ideal_non_coverage_hours:
                    analyticsDataResponse.results[i][key]
                      .ideal_non_coverage_hours,
                  ideal_coverage_hours:
                    analyticsDataResponse.results[i][key].ideal_coverage_hours,
                  total_sheduled_labour_hours:
                    analyticsDataResponse.results[i][key]
                      .total_sheduled_labour_hours,
                  sheduled_non_coverage_hours:
                    analyticsDataResponse.results[i][key]
                      .sheduled_non_coverage_hours,
                  sheduled_coverage_hours:
                    analyticsDataResponse.results[i][key]
                      .sheduled_coverage_hours,
                  total_wastage_labour_hours:
                    analyticsDataResponse.results[i][key]
                      .total_wastage_labour_hours,
                  wastage_non_coverage_hours:
                    analyticsDataResponse.results[i][key]
                      .wastage_non_coverage_hours,
                  wastage_coverage_hours:
                    analyticsDataResponse.results[i][key]
                      .wastage_coverage_hours,
                  var_to_idl_coverage_hours:
                    analyticsDataResponse.results[i][key]
                      .var_to_idl_coverage_hours,
                  var_to_idl_non_coverage_hours:
                    analyticsDataResponse.results[i][key]
                      .var_to_idl_non_coverage_hours,
                  var_to_idl_total:
                    analyticsDataResponse.results[i][key].var_to_idl_total,
                  var_to_shdl_total:
                    analyticsDataResponse.results[i][key].var_to_shdl_total,
                  vairance_to_shedule:
                    analyticsDataResponse.results[i][key].vairance_to_shedule,
                  var_to_actual_total:
                    analyticsDataResponse.results[i][key].var_to_actual_total,
                  total_sheduled_labour_hours_ft:
                    analyticsDataResponse.results[i][key].total_sheduled_labour_hours_ft,
                  total_sheduled_labour_hours_pt:
                  analyticsDataResponse.results[i][key].total_sheduled_labour_hours_pt,
                  actual_labour_hours_ft:
                    analyticsDataResponse.results[i][key].actual_labour_hours_ft,
                  actual_labour_hours_pt:
                  analyticsDataResponse.results[i][key].actual_labour_hours_pt,
                  scheduled_overtime:
                  analyticsDataResponse.results[i][key].scheduled_overtime,
                  actual_overtime:
                  analyticsDataResponse.results[i][key].actual_overtime,
                  sale_amount:
                    analyticsDataResponse.results[i][key].sale_amount,
                  actual_overtime_cost:
                    analyticsDataResponse.results[i][key].actual_overtime_cost,
                  scheduled_overtime_cost:
                    analyticsDataResponse.results[i][key]
                      .scheduled_overtime_cost,
                  part_time_per:
                    analyticsDataResponse.results[i][key].part_time_per,
                  full_time_per:
                    analyticsDataResponse.results[i][key].full_time_per,
                  male_per: analyticsDataResponse.results[i][key].male_per,
                  female_per: analyticsDataResponse.results[i][key].female_per,
                  shift_compliment:
                    analyticsDataResponse.results[i][key].shift_compliment,
                  actual_iplh:
                    analyticsDataResponse.results[i][key].actual_iplh,
                  actual_tplh:
                    analyticsDataResponse.results[i][key].actual_tplh,
                  target_iplh:
                    analyticsDataResponse.results[i][key].target_iplh,
                  target_tplh:
                    analyticsDataResponse.results[i][key].target_tplh,
                  achievement_iplh:
                    analyticsDataResponse.results[i][key].achievement_iplh,
                  achievement_tplh:
                    analyticsDataResponse.results[i][key].achievement_tplh,
                  actual_labour_hours:
                    analyticsDataResponse.results[i][key].actual_labour_hours,
                  actual_non_coverage_hours:
                    analyticsDataResponse.results[i][key]
                      .actual_non_coverage_hours,
                  actual_coverage_hours:
                    analyticsDataResponse.results[i][key].actual_coverage_hours,
                  planned_manpower:
                    analyticsDataResponse.results[i][key].planned_manpower,
                  projected_man_power:
                    analyticsDataResponse.results[i][key].projected_man_power,
                  actual_manpower:
                    analyticsDataResponse.results[i][key].actual_manpower,

                  scheduled_hours:
                    analyticsDataResponse.results[i][key].scheduled_hours,
                  actual_hours:
                    analyticsDataResponse.results[i][key].actual_hours,
                  target_lc: analyticsDataResponse.results[i][key].target_lc,
                  scheduled_lc:
                    analyticsDataResponse.results[i][key].scheduled_lc,
                  actual_lc: analyticsDataResponse.results[i][key].actual_lc,
                  sva_hour_var:
                    analyticsDataResponse.results[i][key].sva_hour_var,
                  sva_lc_var: analyticsDataResponse.results[i][key].sva_lc_var,
                  tva_lc_var: analyticsDataResponse.results[i][key].tva_lc_var,
                  sch_lc_act_sales_percentage: analyticsDataResponse.results[i][key].sch_lc_act_sales_percentage,
                  actual_lc_percentage: analyticsDataResponse.results[i][key].actual_lc_percentage,
                  scheduled_iplh: analyticsDataResponse.results[i][key].scheduled_iplh,
                  scheduled_tplh: analyticsDataResponse.results[i][key].scheduled_tplh,
                };
                data.push(obj);
                // data.push(analyticsDataResponse.results[i][key].total_ideal_labour_hours);
                // data.push(analyticsDataResponse.results[i][key].ideal_non_coverage_hours);
                // data.push(analyticsDataResponse.results[i][key].ideal_coverage_hours);
                // data.push(analyticsDataResponse.results[i][key].total_sheduled_labour_hours);
                // data.push(analyticsDataResponse.results[i][key].sheduled_non_coverage_hours);
                // data.push(analyticsDataResponse.results[i][key].sheduled_coverage_hours);
                // data.push(analyticsDataResponse.results[i][key].total_wastage_labour_hours);
                // data.push(analyticsDataResponse.results[i][key].wastage_non_coverage_hours);
                // data.push(analyticsDataResponse.results[i][key].wastage_coverage_hours);
              }
            }
            this.analyticsDataResponse = analyticsDataResponse;
            this.tableData = data;
            let newData = this.consoleData;
            newData.name = "Consolidated";
            // newData.actual_coverage_hours = 0;
            // newData.actual_non_coverage_hours = 0;
            // newData.actual_labour_hours = 0;

            // if(!this.filters.countries.length && !this.filters.regions.length &&!this.filters.subregions.length && !this.filters.outlets.length) {
            this.tableData.unshift(newData);
            // }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goDashboard() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.consolidatedData();
        }
      });

      this.report_from_date = this.fromDate;
      this.report_to_date = this.toDate;
      this.report_type = this.view;
    },

    applyFilters() {
      this.is_workforce_loading = true; //enabled loader
      this.show_wfd_data = true;
      this.tableData = [];

      //   this.view == "wtd" ? this.fromDate = moment(new Date()).day(1): this.view == "mtd" ? this.fromDate = moment(new Date()).startOf('month') : this.view == "ytd" ?  this.fromDate = moment().quarter(2).startOf('quarter').format('YYYY-MM-DD') : this.fromDate = moment(
      //     new Date(new Date().setDate(new Date().getDate() - 1))
      //   ).format("YYYY-MM-DD");

      //   this.consolidatedData();
      var params = {
        start_date: moment(this.fromDate).format("YYYY-MM-DD"),
        end_date: moment(this.toDate).format("YYYY-MM-DD"),
        view: "dashboard",
        quickreport: this.view,
        basics: this.basics,
        filters: this.filters,
        wfp_department: this.selectedDepartment == "null" ? null : this.selectedDepartment
      };

      return serverAddr
        .post(`/sheduling/reports/analytics/?page=${this.pageInfo.currentPage}&page_size=${this.pageInfo.pageSize}`, params)
        .then((response) => {
          if (response.status == 200) {
            let analyticsDataResponse = this.getOutletsMapping(JSON.parse(response.data));

            this.is_workforce_loading = false; //disabled loader
            return analyticsDataResponse;
          } else {
            this.analyticsDataResponse = [];
            this.is_workforce_loading = false; //disabled loader
          }
        })
        .catch((error) => {
          console.log(error);
          this.is_workforce_loading = false; //disabled loader
        }).finally(()=>{
          // Check data availability and show dashboard
          this.show_wfd_data = this.tableData.length ? true : false;  
        });
    },

    consolidatedData() {
      this.applyFilters();
      var params = {
        start_date: moment(this.fromDate).format("YYYY-MM-DD"),
        end_date: moment(this.toDate).format("YYYY-MM-DD"),
        view: "dashboard",
        quickreport: this.view,
        basics: null,
        filters: this.filters,
        wfp_department: this.selectedDepartment == "null" ? null : this.selectedDepartment
      };
      serverAddr
        .post(`/sheduling/reports/analytics/`, params)
        .then((response) => {
          if (response.status == 200) {
            let key = "1";
            this.consoleData = JSON.parse(response.data).results[0][key];
            let data = {
              name: "Labour Hours",
              data: [
                {
                  name: "Ideal",
                  actual: this.consoleData.total_ideal_labour_hours,
                  ideal: this.consoleData.ideal_coverage_hours,
                  scheduled: this.consoleData.ideal_non_coverage_hours,
                },
                {
                  name: "Scheduled",
                  actual: this.consoleData.total_sheduled_labour_hours,
                  ideal: this.consoleData.sheduled_coverage_hours,
                  scheduled: this.consoleData.sheduled_non_coverage_hours,
                },
                {
                  name: "Actual",
                  actual: this.consoleData.actual_labour_hours,
                  ideal: this.consoleData.actual_coverage_hours,
                  scheduled: this.consoleData.actual_non_coverage_hours,
                },
              ],
            };

            let wastage = [
              {
                name: "coverage hours",
                actual: this.consoleData.var_to_idl_coverage_hours,
                ideal: this.consoleData.wastage_coverage_hours,
                scheduled: 0,
              },
              {
                name: "Non Coverage Hours",
                actual: this.consoleData.var_to_idl_non_coverage_hours,
                ideal: this.consoleData.wastage_non_coverage_hours,
                scheduled: 0,
              },
              {
                name: "Total",
                actual: this.consoleData.var_to_idl_total,
                ideal: this.consoleData.total_wastage_labour_hours,
                scheduled: 0,
              },
            ];

            let iplhdata = {
              name: "IPLH",
              data: [
                {
                  name: "Ideal",
                  actual: this.consoleData.achievement_iplh,
                  ideal: this.consoleData.actual_iplh,
                  scheduled: this.consoleData.target_iplh,
                },
              ],
            };
            this.selectedLabourHrs = true;
            this.selectedIplh = true;
            EventBus.$emit("reponseLabourHoursGraph", data);
            EventBus.$emit("reponseVarianceGraph", wastage);
            EventBus.$emit("reponseIplhGraph", iplhdata);
            EventBus.$emit("reponsePieChart", [
              {
                value: this.consoleData.part_time_per,
                name: "Flexible",
              },
              {
                value: this.consoleData.full_time_per,
                name: "Full Time",
              },
            ]);
          }

          let newData = this.consoleData;
          newData.name = "Consolidated";
          // newData.actual_coverage_hours = 0;
          // newData.actual_non_coverage_hours = 0;
          // newData.actual_labour_hours = 0;
          // this.tableData.unshift(this.consoleData);
          this.changedIplhGraph('IPLH');
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getEmployeeLabourCost(lable) {
      // console.log('getEmployeeLabourCost', this.basics, lable, this.storeMappings);
      if (this.basics == "outlet" && lable != "Consolidated") {
        this.selected_store_name = lable;

        this.selected_outlet = this.storeMappings.filter((e) => {
          return this.selected_store_name == e.name;
        });

        if (this.selected_outlet.length) {
          // this.dialog_visible = true;
          this.transaction_dialog_visible = true;

          this.report_from_date = this.fromDate; //assgined from, to date and view initially
          this.report_to_date = this.toDate;

          this.report_type = this.view;

          this.getCommonLabourCostAndHours(); //function to get common response for consolidated data
        }
      }
    },

    async getCommonLabourCostAndHours() {
      // for_date
      this.is_labour_cost_details_loading = true; //enabled loader

      // reset table details
      this.labour_cost_table_details = {
        consolidated: [],
        date_consolidated: [],
      };

      let filters = {
        outlets: [],
      };

      filters.outlets.push(this.selected_outlet[0].id);

      let consolidated_response = await this.getLabourCostDetailsNetworkCallBack(filters, null); //get consolidated data
      // console.log('consolidated_response', consolidated_response);

      let date_consolidated_response = await this.getLabourCostDetailsNetworkCallBack(filters, "date"); //get department's consolidated data

      // let dept_consolidated_response = await this.getLabourCostDetailsNetworkCallBack(filters, "wfp_department"); //get department's consolidated data
      // console.log('dept_consolidated_response', dept_consolidated_response);

      // let emp_consolidated_response = await this.getLabourCostDetailsNetworkCallBack(filters, "employee"); //get department wise employee's consolidated data
      // console.log('emp_consolidated_response', emp_consolidated_response);

      if (consolidated_response && consolidated_response.length) {
        this.labour_cost_table_details.consolidated = consolidated_response;
      }

      if (date_consolidated_response && date_consolidated_response.length) {
        // dept_consolidated_response.forEach((e) => {
        //   this.$set(e, "employees", []); //created blank array to push employees of department

        //   // filtering employees by department id
        //   e.employees = emp_consolidated_response.filter((emp) => {
        //     return e.basics == emp.store_department_id;
        //   });
        // });
        this.labour_cost_table_details.date_consolidated = date_consolidated_response;
      }

      this.is_labour_cost_details_loading = false; //disabled loader
    },

    async getEmployeeLabourCostAndHours(selected_date) {
      this.dialog_visible = true;
      this.selected_date = selected_date;

      this.is_employee_cost_details_loading = true; //enabled loader

      // reset table details
      this.employee_cost_table_details = {
        consolidated: [],
        department_consolidated: []
      };

      let filters = {
        outlets: []
      };

      filters.outlets.push(this.selected_outlet[0].id);

      let consolidated_response = await this.getLabourCostDetailsNetworkCallBack(filters, 'employee_consolidated', selected_date); //get consolidated data
      // console.log('consolidated_response', consolidated_response);

      let department_consolidated_response = await this.getLabourCostDetailsNetworkCallBack(filters, "wfp_department", selected_date); //get department's consolidated data
      // console.log('department_consolidated_response', department_consolidated_response);

      let employee_consolidated_response = await this.getLabourCostDetailsNetworkCallBack(filters, "employee", selected_date); //get employee data
      // console.log('employee_consolidated_response', employee_consolidated_response);

      if (consolidated_response && consolidated_response.length) {
        this.employee_cost_table_details.consolidated = consolidated_response;
      }

      if (department_consolidated_response && department_consolidated_response.length && employee_consolidated_response && employee_consolidated_response.length) {

        department_consolidated_response.forEach((e) => {
          this.$set(e, "employees", []); //created blank array to push employees of the department

          // filtering employees by department id
          e.employees = employee_consolidated_response.filter((emp) => {
            return e.basics == emp.store_department_id;
          });
        });

        this.employee_cost_table_details.department_consolidated = department_consolidated_response;
      }

      this.is_employee_cost_details_loading = false; //disabled loader
    },

    getLabourCostDetailsNetworkCallBack(filters, basics, selected_date) {
      var params = {
        start_date: moment(this.report_from_date).format("YYYY-MM-DD"),
        end_date: moment(this.report_to_date).format("YYYY-MM-DD"),
        quickreport: this.report_type == "wfr" ? null : this.report_type,
        basics: basics,
        filters: filters,
        // "start_date": "2022-01-01",
        // "end_date": "2022-01-15",
        // "quickreport": "ytd",
        // basics: basics,
        // "include_dates":"False",
        // "for_date":"2022-01-13",
        // "filters": {
        //   "outlets": ["1586acb4-e528-4bf4-87a1-9f624a23df5e"]
        // }
      };

      if (selected_date) {
        params.for_date = selected_date;
      }

      return serverAddr
        .post(`sheduling/reports/labour-cost/?get_all=true`, params)
        .then((response) => {
          if (response.status == 200) {
            var res = JSON.parse(response.data);
            return res;
          }
        })
        .catch((error) => {
          console.log(error);
          this.is_labour_cost_details_loading = false; //disabled loader
        });
    },

    editComment(emp, emp_index, department_index) {
      // console.log('editComment', emp, emp_index, department_index);
      this.department_index = department_index;
      this.employee_index = emp_index;

      this.comment = emp.comments;

      this.edit_comment_dialog_visible = true;      //open add/edit comment dialog
    },

    saveComment() {
      this.is_comments_updating = true;  //enabled button loader

      console.log(this.employee_cost_table_details.department_consolidated[this.department_index]);
      console.log(this.employee_cost_table_details.department_consolidated[this.department_index].employees[this.employee_index]);

      let params = {
        basics_id: this.employee_cost_table_details.department_consolidated[this.department_index].employees[this.employee_index].basics_id,
        emp_id: this.employee_cost_table_details.department_consolidated[this.department_index].employees[this.employee_index].emp_id,
        for_date: this.employee_cost_table_details.department_consolidated[this.department_index].employees[this.employee_index].for_date,
        comments: this.comment,
        operation: 'add_update'
      }

      serverAddr
        .post(`sheduling/reports/labor-cost/add-update comments/`, params)
        .then((response) => {
          if (response.status == 200) {
            this.employee_cost_table_details.department_consolidated[this.department_index].employees[this.employee_index].comments = this.comment;

            this.is_comments_updating = false;  //disabled button loader
            this.edit_comment_dialog_visible = false;     // add/edit comment dialog

            this.$notify.success({
              title: "Success",
              message: "Comment updated",
              type: "success"
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.is_comments_updating = false;  //disabled button loader
          this.is_labour_cost_details_loading = false; //disabled loader
        });
    },

    deleteComment(emp, emp_index, department_index) {
      this.$confirm(`Are you sure to continue?`, 'Alert!', {
        confirmButtonText: 'OK',
        // showCancelButton: false,
        dangerouslyUseHTMLString: true
      }).then(() => {
        let params = {
          basics_id: this.employee_cost_table_details.department_consolidated[this.department_index].employees[this.employee_index].basics_id,
          emp_id: this.employee_cost_table_details.department_consolidated[this.department_index].employees[this.employee_index].emp_id,
          for_date: this.employee_cost_table_details.department_consolidated[this.department_index].employees[this.employee_index].for_date,
          comments: '',
          operation: 'delete'
        }

        serverAddr
          .post(`sheduling/reports/labor-cost/add-update comments/`, params)
          .then((response) => {
            if (response.status == 200) {
              this.employee_cost_table_details.department_consolidated[this.department_index].employees[this.employee_index].comments = '';

              this.$notify.success({
                title: "Success",
                message: "Comment deleted",
                type: "success"
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }).catch(() => {
      });
    },

    async createPDF() {
      var doc = new jsPDF("l", "pt", "a4", true);

      let base_labour_hour_graph = await this.getImageDataUrl("baseLabourHourGraph");

      let base_iplh_graph = await this.getImageDataUrl("baseIplhGraph");

      let variance_graph = await this.getImageDataUrl("varianceGraph");

      let base_pie_chart = await this.getImageDataUrl("basePieChart");

      doc.setFontSize(20);
      var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

      doc.text("Workforce dashboard", pageWidth / 2, 25, "center"); //center title

      // pdf.imagePlace(20, 40);

      doc.addImage(base_labour_hour_graph, "JPEG", 80, 40, 180, 160); //x, y, height, width

      doc.addImage(base_iplh_graph, "JPEG", 550, 40, 180, 160);

      doc.addImage(variance_graph, "JPEG", 80, 220, 180, 160);

      doc.addImage(base_pie_chart, "JPEG", 550, 220, 180, 160);
      // doc.addImage(imgData, 'JPEG', 30, 30, 120, 45, 'center');

      doc.save(`workfoce-dashboard.pdf`);
    },

    getImageDataUrl(node_id) {
      var node = document.getElementById(node_id);

      return domtoimage
        .toPng(node)
        .then((dataUrl) => {
          return dataUrl;
        })
        .catch(function (error) {
          console.error("oops, something went wrong!", error);
        });
    },

    createCsvJson(tableData) {
      return tableData.map((el) => {
        return {
          "STORE NAME": el.name,
          "TRANS PROJECTED": el.forecast_transaction,
          "TRANS ADJUSTED": el.adjusted_forecast_transaction,
          "TRANS ACTUAL": el.actual_transactions,
          "FORECAST ACCURACY PERCENTAGE": el.accuracy,
          "ILH COVERAGE HOURS": el.ideal_coverage_hours,
          "ILH NON COVERAGE HOURS": el.ideal_non_coverage_hours,
          "ILH TOTAL": el.total_ideal_labour_hours,
          "SLH COVERAGE HOURS": el.sheduled_coverage_hours,
          "SLH NON COVERAGE HOURS": el.sheduled_non_coverage_hours,
          "SLH TOTAL": el.total_sheduled_labour_hours,
          "ALH COVERAGE HOURS": el.actual_coverage_hours,
          "ALH NON COVERAGE HOURS": el.actual_non_coverage_hours,
          "ALH TOTAL": el.actual_labour_hours,
          "WH COVERAGE HOURS": el.wastage_coverage_hours,
          "WH NON COVERAGE HOURS": el.wastage_non_coverage_hours,
          "WH TOTAL": el.total_wastage_labour_hours,
          "VTI COVERAGE HOURS": el.var_to_idl_coverage_hours,
          "VTI NON COVERAGE HOURS": el.var_to_idl_non_coverage_hours,
          "VTI TOTAL": el.var_to_idl_total,
          "VTS TOTAL": el.vairance_to_shedule,
          "LC TARGET": el.target_lc,
          "LC SCHEDULE": el.scheduled_lc,
          "LC ACTUAL": el.actual_lc,
          "LC TARGET vs ACTUAL": el.tva_lc_var,
          "LC SCHEDULE vs ACTUAL": el.sva_lc_var,

          "PART TIME": el.part_time_per,
          "FULL TIME": el.full_time_per,
          MALE: el.male_per,
          FEMALE: el.female_per,
          "SHIFT COMPLEMENT": el.shift_compliment,
          "IPLH ACTUAL": el.actual_iplh,
          "IPLH TARGET": el.target_iplh,
          "IPLH ACHIEVEMENT": el.achievement_iplh,
        };
      });
    },
    downloadAllCsvReports(command){
      if(command == 'consolidated') {
        this.downloadCsvReport('csv');
      } else if(command == 'pillar') {
        this.generateFourPillarReport();
      } else if(command == 'variance') {
        this.generateVarianceReport();
      } else if(command == 'company') {
        this.downloadSBReport('week');
      } else if(command == 'day_wise') {
        this.downloadSBReport('date');
      }
    },
    generateFourPillarReport() {
      var params = {
        start_date: moment(this.fromDate).format("YYYY-MM-DD"),
        end_date: moment(this.toDate).format("YYYY-MM-DD")
      };
      this.addDownloadingReportCountAction();
      serverAddrForXLSX
        .post(`/sheduling/reports/pillar-report-download/`, params)
        .then(response => {
          if (response.status == 200) {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", `${'Four-Pillar-Report-'+params.start_date+'-'+params.end_date+'.xlsx'}`);
            document.body.appendChild(fileLink);
            fileLink.click();
          }
          this.removeDownloadingReportCountAction();
        })
        .catch(err => {
          this.abortDownloadingReportCountAction();
          console.log(err);
          this.$notify.error({
            title: "Error",
            message: "Something went wrong!"
          });
        });
    },
    downloadSBReport(report){
      this.is_csv_loading = true;   //displayed loader on button
      this.addDownloadingReportCountAction();
      var params = {
        start_date: moment(this.fromDate).format("YYYY-MM-DD"),
        end_date: moment(this.toDate).format("YYYY-MM-DD"),
        view: "dashboard",
        quickreport: this.view,
        basics: this.basics,
        filters: this.filters,
        aggregate: report
      };
      serverAddrForXLSX
        .post(`/sheduling/reports/download/daily-weekly-report-download/`, params)
        .then(response => {
          if (response.status == 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            const report_name = (report === 'date') ? 'Daywise_Report-' : 'Company_Report-';
            link.setAttribute("download", `${ report_name +params.start_date+'/'+params.end_date+'.xlsx'}`);
            document.body.appendChild(link);

            link.click();
          }
          this.removeDownloadingReportCountAction();
          this.is_csv_loading = false;   //hide loader on button
        })
        .catch(err => {
          console.log(err);
          this.is_csv_loading = false;   //hide loader on button
          this.abortDownloadingReportCountAction();
          this.$notify.error({
            title: "Error",
            message: "Something went wrong!"
          });
        });
    },
    generateVarianceReport() {
      var params = {
        start_date: moment(this.fromDate).format("YYYY-MM-DD"),
        end_date: moment(this.toDate).format("YYYY-MM-DD")
      };
      this.addDownloadingReportCountAction();
      serverAddrForXLSX
        .post(`/sheduling/reports/variance-report-download/`, params)
        .then(response => {
          if (response.status == 200) {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", `${'Variance-Report-'+params.start_date+'-'+params.end_date+'.xlsx'}`);
            document.body.appendChild(fileLink);
            fileLink.click();
          }
          this.removeDownloadingReportCountAction();
        })
        .catch(err => {
          this.abortDownloadingReportCountAction();
          console.log(err);
          this.$notify.error({
            title: "Error",
            message: "Something went wrong!"
          });
        });
    },
    downloadCsvReport(extension) {
      this.is_csv_loading = true;   //displayed loader on button
      this.addDownloadingReportCountAction();
      //   var export_csv = this.createCsvJson(this.tableData);
      //   // *****************download csv file************************************
      //   var csv = Papa.unparse(export_csv);
      //   console.log(export_csv);
      //   var csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });

      //   var csvURL = null;
      //   if (navigator.msSaveBlob) {
      //     csvURL = navigator.msSaveBlob(csvData, "download.csv");
      //   } else {
      //     csvURL = window.URL.createObjectURL(csvData);
      //   }

      //   var tempLink = document.createElement("a");
      //   tempLink.href = csvURL;
      //   tempLink.setAttribute("download", `WorkforceReport.${extension}`);
      //   tempLink.click();

      var params = {
        start_date: moment(this.fromDate).format("YYYY-MM-DD"),
        end_date: moment(this.toDate).format("YYYY-MM-DD"),
        view: "dashboard",
        quickreport: this.view,
        basics: this.basics,
        filters: this.filters
      };
      serverAddrForCSV
        .post(`/sheduling/reports/report-download/`, params)
        .then(response => {
          if (response.status == 200) {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", `${'WorkforceReport-'+params.start_date+'/'+params.end_date+'.csv'}`);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          this.removeDownloadingReportCountAction();
          this.is_csv_loading = false;   //hide loader on button
        })
        .catch(err => {
          console.log(err);
          this.is_csv_loading = false;   //hide loader on button
          this.abortDownloadingReportCountAction();
          this.$notify.error({
            title: "Error",
            message: "Something went wrong!"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./WrokForceDashboard.scss";

.tab-heding {
  border-color: #e29d5a;
  cursor: pointer;
  color: #e29d5a;
  font-size: 14px;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.selected-tab-heding {
  border-bottom-width: 2px;
  border-color: #e29d5a;
  font-size: 14px;
  cursor: pointer;
  color: #e29d5a;
  font-weight: bold;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
</style>

<style lang="scss">
.el-tooltip__popper {
  max-width: 500px;
  font-size: 14px;
  text-transform: capitalize;
}

.WrokForceDashboard .customClass {
  position: absolute;
  right: 0;
  // min-height: 100vh;
  margin: 0;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 1rem 1rem 0 1rem;
    color: unset;
    // min-height: 100vh;
    background: #f8f8f8;
  }
}

// .WrokForceDashboard .el-input__inner {
//   height: 37px !important;
// }
.Consolidated {
  color: #000;
  font-weight: bold;
}

.WrokForceDashboard {
  .el-button {
    min-width: unset;
  }
}

.ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 120px;
}

.el-popover {
  font-size: 12px;
  word-break: break-word;
}
.box-350{
  width: 350px;
}

.el-cascader__tags .el-tag>span {

    text-transform: capitalize;
}


.el-cascader-panel:first-child .el-cascader-menu>.el-cascader-menu__wrap {
    height: 335px !important;
}
</style>
